export const es = {
  // General
  appName: 'V·IANet Governance',
  brandName: 'VALOR·IA Governance',
  poweredBy: 'powered by',

  // Sidebar
  sidebar: {
    explorer: 'Explorador de Documentos',
    processMap: 'MAPA DE PROCESOS',
    collapseAll: '▶ Todo',
    expandAll: '▼ Todo',
    strategic: 'Procesos Estratégicos',
    operational: 'Procesos Operativos',
    support: 'Procesos de Soporte',
    structure: 'Estructura',
    process: 'Procesos',
    information: 'Información',
    compliance: 'Cumplimiento',
    tech: 'Tecnología',
    reputation: 'Reputación',
    settings: 'Configuración',
    ingenierias: 'Ingenierías',
    actionCenter: 'Centro de acciones',
    allOrgs: 'Todas las organizaciones',
    cambiarTenant: 'Cambiar organización',
    salir: 'Salir',
    userMenu: {
      miCuenta: 'Mi cuenta',
      backoffice: 'Backoffice',
      cambiarOrganizacion: 'Cambiar organización',
      cerrarSesion: 'Cerrar sesión',
      superadminBadge: 'Admin Plataforma',
      rolBadge: 'Rol',
    },
    pageTitle: {
      processMap: 'Gobernanza Corporativa',
      structure: 'Estructura Organizativa',
      process: 'Arquitectura de Procesos',
      information: 'Gestión de la Información de Negocio',
      compliance: 'Cumplimiento Normativo',
      tech: 'Tecnologías de la Información',
      reputation: 'Gestión de la Comunicación Reputacional',
      settings: 'Configuración',
    },
  },

  // Explorer
  explorer: {
    title: 'Explorador de Documentos',
    subtitle: (total: number) => `${total} documentos en el sistema de gestión`,
    totalDocs: 'Total documentos',
    published: 'Vigentes',
    draft: 'Borrador',
    inReview: 'En revisión',
    allTypes: 'Todos los tipos',
    allStates: 'Todos los estados',
    allProcesses: 'Todos los procesos',
    search: 'Buscar documentos...',
    clearFilters: '✕ Limpiar',
    showing: (from: number, to: number, total: number) =>
      `Mostrando ${from}–${to} de ${total} documentos`,
    noResults: 'No se encontraron documentos',
    newDocument: '+ Nuevo documento',
    previous: '← Anterior',
    next: 'Siguiente →',
  },

  // Table headers
  table: {
    code: 'Código',
    title: 'Título',
    type: 'Tipo',
    process: 'Proceso',
    status: 'Estado',
    direction: 'Dir.',
    edition: 'Ed.',
    date: 'Fecha',
  },

  // Document types
  docType: {
    PR: 'Procedimiento',
    NC: 'Norma Corporativa',
    IT: 'Instrucción de Trabajo',
    MN: 'Manual',
    PA: 'Plan de Acción',
    RE: 'Reporte',
    FC: 'Ficha de Caracterización',
    FL: 'Flujograma',
    HE: 'Herramienta',
    MO: 'Modelo',
    PT: 'Protocolo',
    FR: 'Ficha de Rol Funcional',
    FP: 'Ficha de Puesto',
    FG: 'Ficha de Rol de Gobernanza',
  },

  // Document states (match EstadoDocumento enum: BORRADOR, EN_REVISION, APROBADO, PUBLICADO, ARCHIVADO)
  status: {
    BORRADOR: 'Borrador',
    EN_REVISION: 'En revisión',
    APROBADO: 'Aprobado',
    PUBLICADO: 'Vigente',
    ARCHIVADO: 'Archivado',
  },

  // Version states (EstadoDocumento + legacy aliases)
  versionStatus: {
    BORRADOR: 'Borrador',
    EN_REVISION: 'En Revision',
    ENVIADO: 'Enviado',
    APROBADO: 'Aprobado',
    PUBLICADO: 'Vigente',
    ARCHIVADO: 'Archivado',
    RECHAZADO: 'Rechazado',
  },

  // Document types (match TipoDocumental enum)
  docTypes: {
    PR: 'Procedimiento',
    NC: 'Norma Corporativa',
    IT: 'Instrucción de Trabajo',
    MN: 'Manual',
    PA: 'Plan de Acción',
    RE: 'Reporte',
    FC: 'Ficha de Caracterización',
    FL: 'Flujograma',
    HE: 'Herramienta',
    MO: 'Modelo',
    PT: 'Protocolo',
    FR: 'Ficha de Rol Funcional',
    FP: 'Ficha de Puesto',
    FG: 'Ficha de Rol de Gobernanza',
  },

  // Process typologies
  typology: {
    PE: 'Procesos Estratégicos',
    PO: 'Procesos Operativos',
    PS: 'Procesos de Soporte',
  },

  // Viewer
  viewer: {
    documentContent: 'CONTENIDO DEL DOCUMENTO',
    searchContent: 'Buscar en contenido...',
    cover: 'Portada',
    tabs: {
      content: 'Contenido',
      metadata: 'Metadatos',
      versions: 'Versiones',
      references: 'Referencias',
    },
    company: 'Empresa',
    direction: 'Dirección',
    edition: 'Edición',
    date: 'Fecha',
    process: 'Proceso',
    elaboratedBy: 'Elaborado por',
    reviewedBy: 'Revisado por',
    approvedBy: 'Aprobado por',
    approvalDate: 'Fecha aprobación',
    exportPDF: 'Exportar PDF',
    edit: 'Editar',
    lifecycle: 'Ciclo de vida',
    outgoing: 'Referencia a',
    incoming: 'Referenciado por',
    noReferences: 'Sin referencias cruzadas',
    versionHistory: 'Historial de versiones',
    noVersions: 'Sin versiones',
    changeDescription: 'Descripción de cambios',
    borradorEnEdicion: 'Hay un borrador en edición',
    verBorrador: 'Ver borrador',
    eliminarBorrador: 'Eliminar borrador',
    confirmarEliminar: '¿Eliminar borrador?',
    eliminarBorradorDesc:
      'Esta acción eliminará permanentemente el borrador. El documento vigente no se verá afectado.',
    borradorEliminado: 'Borrador eliminado',
    eliminar: 'Eliminar',
    archivar: 'Archivar',
    confirmarArchivar: '¿Archivar documento?',
    archivarDesc:
      'El documento pasará a estado Archivado y dejará de estar vigente. Esta acción puede revertirse.',
    documentoArchivado: 'Documento archivado',
  },

  // Editor
  editor: {
    save: 'Guardar',
    close: 'Cerrar',
    saving: 'Guardando...',
    saved: 'Guardado',
    savedAt: (time: string) => `Guardado: ${time}`,
    autosave: 'Autoguardado cada 30s',
    unsavedChanges: 'Cambios sin guardar',
    addBlock: '+ Añadir bloque',
    aiAssistant: '✨ Asistente IA',
    wordCount: (n: number) => `${n} palabras`,
    // GenerateAIDialog / ImportDocxDialog keys
    generateAI: 'Generar con VALOR·IA',
    generateAIDesc: 'Describe qué contenido quieres generar para este documento.',
    generateUnavailable: 'Generación IA no disponible aún. Disponible en próxima versión.',
    generatePlaceholder: 'Genera la sección de Definiciones para este procedimiento...',
    generate: 'Generar',
    insertAtEnd: 'Insertar al final',
    insertAtCursor: 'Insertar en cursor',
    importDocx: 'Importar DOCX',
    dragDocx: 'Arrastra un archivo .docx o haz clic para seleccionar',
    processingDocx: 'Procesando...',
    insertContent: 'Insertar contenido',
    crossRefPlaceholder: 'Buscar por codigo (ej: PE.21.NC)...',
    crossRefNoResults: 'Sin resultados. Pulsa Enter para insertar manualmente.',
    crossRefNavigate: 'navegar',
    crossRefSelect: 'seleccionar',
    crossRefClose: 'cerrar',
    styles: {
      headings: 'Encabezados',
      paragraph: 'Párrafo',
      lists: 'Listas',
      table: 'Tabla',
      character: 'Carácter',
    },
    toolbar: {
      undo: 'Deshacer',
      redo: 'Rehacer',
      bold: 'Negrita',
      italic: 'Cursiva',
      underline: 'Subrayado',
      bulletList: 'Lista viñetas',
      orderedList: 'Lista numerada',
      table: 'Tabla',
      crossRef: 'Referencia cruzada',
      image: 'Imagen',
      normNote: 'Nota normativa',
      codeBlock: 'Bloque código',
      hr: 'Línea horizontal',
      importDocx: 'Importar DOCX',
      generateAI: 'Generar con IA',
    },
    table: {
      rowAbove: 'Fila arriba',
      rowBelow: 'Fila abajo',
      colLeft: 'Col. izquierda',
      colRight: 'Col. derecha',
      deleteRow: 'Eliminar fila',
      deleteCol: 'Eliminar columna',
      deleteTable: 'Eliminar tabla',
      mergeCells: 'Unir celdas',
      splitCell: 'Dividir celda',
    },
    floatingToolbar: {
      improveWriting: 'Mejorar redacción',
      expandContent: 'Ampliar contenido',
      summarize: 'Resumir',
      translate: 'Traducir ES↔EN',
      verifyCoherence: 'Verificar coherencia',
      suggestRefs: 'Sugerir referencias',
    },
    aiPanel: {
      title: 'Asistente IA',
      subtitle: 'Gobernanza documental',
      draftSection: 'Redactar sección',
      completeStructure: 'Completar estructura',
      verifyCoherence: 'Verificar coherencia',
      crossRefs: 'Referencias cruzadas',
      translate: 'Traducir',
      placeholder: 'Escribe tu pregunta...',
    },
    suggestion: {
      accept: 'Aceptar (Tab)',
      discard: 'Descartar',
      regenerate: 'Regenerar',
      badge: '✨ Sugerencia IA',
    },
  },

  // Process sheet
  processSheet: {
    exportPDF: 'Exportar PDF',
    edit: 'Editar',
    aiAssistant: '✨ Asistente IA',
    sections: {
      identification: 'Identificación',
      description: 'Descripción',
      inputsOutputs: 'Entradas y Salidas',
      reportsRequirements: 'Reportes y Requisitos',
      documentation: 'Documentación',
      tools: 'Herramientas',
      indicators: 'Indicadores',
    },
    fields: {
      name: 'Nombre',
      code: 'Código',
      type: 'Tipo',
      group: 'Grupo funcional',
      responsible: 'Responsable',
      involved: 'Involucrados',
      scope: 'Alcance',
      inputs: 'Entradas',
      outputs: 'Salidas',
      origin: 'Origen',
      destination: 'Destino',
      reports: 'Reportes',
      requirements: 'Requisitos',
      objective: 'Objetivo',
      frequency: 'Frecuencia',
      phase: 'Fase',
    },
    freq: {
      mensual: 'Mensual',
      trimestral: 'Trimestral',
      semestral: 'Semestral',
      anual: 'Anual',
    },
    aiActions: {
      completeDescription: 'Completar descripción',
      suggestIO: 'Sugerir entradas/salidas',
      proposeIndicators: 'Proponer indicadores',
      verifyCoherence: 'Verificar coherencia',
      generateSheet: 'Generar ficha completa',
    },
    editing: 'Editando...',
    addItem: 'Añadir',
    removeItem: 'Eliminar',
    saved: 'Guardado',
    noData: 'Sin datos registrados',
    placeholders: {
      descripcion: 'Descripción...',
      unidad: 'Unidad...',
      objetivo: 'Objetivo...',
      frecuencia: 'Frecuencia...',
      destinatario: 'Destinatario...',
      codigo: 'Código...',
      modulo: 'Módulo V·IAnet...',
    },
  },

  // M16 Requests — user-facing
  // Workflow actions (ampliado en 0628 para WorkflowBar shared ADR-025; hints i18n en 0651)
  workflow: {
    sendToReview: 'Enviar a revisión',
    sendToApproval: 'Enviar a aprobación',
    approve: 'Aprobar',
    reject: 'Rechazar',
    publish: 'Publicar',
    returnToDraft: 'Devolver a borrador',
    newEdition: 'Nueva edición',
    archive: 'Archivar',
    discard: 'Descartar',
    reopen: 'Reabrir',
    motivoRechazoPrompt: 'Motivo del rechazo (obligatorio)',
    motivoRechazoRequerido: 'El motivo es obligatorio.',
    confirmarAccion: '¿Confirmas la acción?',
    // 0665: cross-artefacto canónico para ENVIAR_REVISION (DOC + ORG + FLUJO + M16).
    asuntoLabel: 'Asunto',
    asuntoPlaceholder: 'Breve resumen del cambio (ej: «Actualización plazo aprobación»)',
    asuntoHint: 'Mínimo 5 caracteres · resumen corto y claro',
    asuntoMinError: 'El asunto debe tener al menos 5 caracteres.',
    alcanceLabel: 'Alcance',
    alcancePlaceholder:
      'Describe qué cambia, por qué y cómo afectará a la organización (qué procesos, áreas o personas se ven afectados).',
    alcanceHint: 'Mínimo 20 caracteres · describe qué/por qué/cómo',
    alcanceMinError: 'El alcance debe tener al menos 20 caracteres.',
    // 0651: hints descriptivos al hover de cada acción (cross-artefacto · WorkflowBar shared).
    hints: {
      enviarRevision:
        'Envía la versión al aprobador. El aprobador recibe una notificación y queda pendiente de su decisión.',
      aprobar:
        'Confirma la versión y la deja en estado APROBADO, lista para publicar. Se genera una firma SES si está configurado.',
      rechazar:
        'Devuelve la versión a estado RECHAZADO con un motivo. El propietario podrá reabrirla para corregir.',
      publicar:
        'Sustituye la versión vigente. La versión publicada anterior pasa a archivado lógico.',
      descartar:
        'Abandona el borrador definitivamente. Acción irreversible — la versión queda en estado DESCARTADO.',
      archivar:
        'Retira la versión publicada del listado activo. La versión queda en estado ARCHIVADO.',
      reabrir:
        'Pasa la versión rechazada a estado BORRADOR para que el propietario pueda editar y reenviar.',
    },
    approvalPreview: {
      willBeSentTo: 'Será enviado a:',
      sourceHierarchy: 'jerarquía',
      sourceProcess: 'proceso',
      sourceFallback: 'Administración del sistema',
    },
    // 0661 ADR-025 ext: keys cross-artefacto del ArtefactoWorkflowBar shared
    // (organigrama + documento + flujograma · UI unificada)
    bar: {
      loading: 'Cargando workflow…',
      firstEditionDescription: 'Primera edición',
      createFirstDraft: 'Crear borrador',
      viewHistory: 'Ver historial de versiones',
      historyButton: (n: number) => `Historial (${n})`,
      newEditionDescription: (n: number) => `Edición ${n}`,
      newEditionButton: (n: number) => `Nueva edición (Ed. ${n})`,
      historyVersions: 'Historial de versiones',
      close: 'Cerrar',
      noVersionsYet: 'No hay versiones aún.',
      onScreen: 'en pantalla',
      publishedAt: 'Publicado',
      editionTooltip: (n: number) => `Edición ${n}`,
      viewEditionTooltip: (n: number) => `Ver edición ${n}`,
      stageBadge: (pos: number, total: number, accion: string) =>
        `Etapa ${pos}/${total} · ${accion}`,
      stageTooltip: (pos: number, total: number, accion: string) =>
        `En etapa ${pos} de ${total}: ${accion}`,
      errorCreatingDraft: (msg: string) => `Error creando borrador: ${msg}`,
      // 0670 — fallback a vigente cuando última edición rechazada/descartada + visibilidad solo-lectura
      fallbackVigenteBadge: 'Última edición rechazada',
      fallbackVigenteTooltip:
        'La última edición fue rechazada o descartada · mostrando la versión publicada vigente.',
      soloVigenteBadge: 'Solo lectura',
      soloVigenteTooltip:
        'No participas en este flujo de aprobación · solo puedes consultar la versión publicada.',
      estados: {
        BORRADOR: 'BORRADOR',
        EN_REVISION: 'EN REVISIÓN',
        APROBADO: 'APROBADO',
        PUBLICADO: 'PUBLICADO',
        RECHAZADO: 'RECHAZADO',
        DESCARTADO: 'DESCARTADO',
        ARCHIVADO: 'ARCHIVADO',
      },
    },
  },

  // Modal new document
  modal: {
    newDocument: 'Nuevo documento',
    selectProcess: 'Seleccionar proceso',
    documentType: 'Tipo documental',
    documentTitle: 'Título del documento',
    direction: 'Dirección',
    edition: 'Edición',
    autoCode: 'Código auto-generado',
    create: 'Crear documento',
    cancel: 'Cancelar',
  },

  // Quick search
  quickSearch: {
    placeholder: 'Buscar documentos, procesos...',
    recent: 'Recientes',
    noResults: 'Sin resultados',
    hint: '⌘K para buscar',
  },

  // Common
  loading: 'Cargando...',
  error: 'Error',
  notFound: 'No encontrado',
  goBack: 'Volver',

  // Engineering names
  engineering: {
    organizacional: 'Organizativa',
    procesos: 'Procesos',
    informacion: 'Información',
    cumplimiento: 'Cumplimiento',
    tecnologica: 'Tecnológica',
    reputacional: 'Reputacional',
  },

  // V·IA Panel & Chat
  via: {
    titulo: 'V·IA — Asistente de Gobernanza',
    panel: {
      generar: 'Generar documento',
      auditar: 'Auditar documento',
      traducir: 'Traducir',
      mejorar: 'Mejorar redaccion',
      ampliar: 'Ampliar contenido',
      resumir: 'Resumir',
      verificarTerminos: 'Verificar terminologia',
      reformular: 'Reformular',
      definirTermino: 'Definir termino',
    },
    chat: {
      placeholder: 'Escribe tu consulta...',
      enviar: 'Enviar',
      saludo: 'Hola, soy V·IA',
      descripcion:
        'Tu asistente de gobernanza corporativa. Conozco todos los procesos, documentos, personas y la estructura organizativa del sistema.',
      hint: 'Pregunta sobre procesos, documentos o normativa.',
      procesando: 'Procesando...',
      asistenteListo: 'Asistente VIA listo',
      seleccioneAccion: 'Seleccione una accion rapida o escriba un mensaje.',
      errorConexion: 'Error de conexion con el servidor VIA.',
      errorRed: 'Error de red',
      errorServidor: 'Error del servidor',
      accionCompletada: 'Accion completada.',
      noDisponible: 'Asistente VIA no disponible aun.',
      expandir: 'Expandir chat',
      contraer: 'Contraer chat',
    },
    contexto: 'Contexto',
    nuevoContexto: 'Nuevo contexto',
    documentoCompleto: 'Documento completo',
    accionesRapidas: 'Acciones rapidas',
    sinAcciones: 'No hay acciones disponibles para el contexto y rol actual.',
    abrirPanel: 'Abrir panel VIA',
    cerrarPanel: 'Cerrar panel',
    inteligenciaNormativa: 'Inteligencia artificial normativa',
    copilot: {
      titulo: 'V·IA Copilot',
      completar: 'Completar esta seccion',
      corregir: 'Revisar y corregir',
      sugerir: 'Sugerir mejoras',
      verificar: 'Verificar conformidad',
      aplicar: 'Aplicar',
      descartar: 'Descartar',
      copiar: 'Copiar',
    },
  },

  // Sugerencias
  sugerencias: {
    titulo: 'Sugerencias',
    pendientes: '{{count}} sugerencia pendiente',
    pendientes_plural: '{{count}} sugerencias pendientes',
    aceptar: 'Aceptar',
    rechazar: 'Rechazar',
    aceptarTodas: 'Aceptar todas',
    rechazarTodas: 'Rechazar todas',
    siguiente: 'Siguiente',
    aceptarSugerencia: 'Aceptar sugerencia',
    rechazarSugerencia: 'Rechazar sugerencia',
  },

  // Topbar (campana de notificaciones, panel desplegable)
  topbar: {
    notifications: {
      title: 'Notificaciones',
      empty: 'Sin notificaciones',
      markAllRead: 'Todo leído',
      sectionPendientes: 'Pendientes vivos',
      sectionNotificaciones: 'Notificaciones',
      tooltipBell: 'Notificaciones',
      tagOrganigrama: 'Organigrama',
      tagDocumento: 'Documento',
      tagFlujograma: 'Flujograma',
      tagProceso: 'Proceso',
    },
  },

  // Admin
  admin: {
    titulo: 'Administracion',
    dashboardTitle: 'Panel de administración',
    tooltips: {
      dashboard: {
        titulo: 'Panel de administración',
        ayuda:
          'Centro de control de la plataforma V·IAnet Governance.\n\nDesde aquí puedes configurar la empresa, gestionar usuarios y roles, activar módulos y supervisar el uso de la Inteligencia Artificial.\n\nLos cambios en esta sección afectan a todos los usuarios del tenant.',
      },
    },
    tabs: {
      dashboard: 'Panel General',
      backoffice: 'Backoffice',
      empresa: 'Empresa',
      usuarios: 'Usuarios',
      modulos: 'Módulos',
      plataforma: 'Plataforma',
      ia: 'Inteligencia Artificial',
      notificaciones: 'Notificaciones',
      sign: 'Firma',
      workflows: 'Flujos de aprobación',
      i18n: 'Idiomas',
    },
    dashboard: {
      totalUsuarios: 'Usuarios Activos',
      totalDocumentos: 'Documentos',
      totalProcesos: 'Procesos',
      publicados: 'Publicados',
      modulos: 'Modulos',
      totalFlujogramas: 'Flujogramas',
      totalAuditorias: 'Auditorias',
      actividadReciente: 'Actividad reciente',
      sinActividad: 'Sin actividad reciente',
      saludSistema: 'Salud del sistema',
      baseDatos: 'Base de Datos',
      operativo: 'Operativo',
      degradado: 'Degradado',
      caido: 'Caido',
      desconocido: 'Desconocido',
      planYUso: 'Plan y uso',
      modulosActivos: '13 modulos activos',
      tokensIA: 'Tokens IA',
      auditoria: 'Auditoria',
      filtrarUsuario: 'Filtrar usuario...',
      exportarCSV: 'CSV',
      fecha: 'Fecha',
      usuario: 'Usuario',
      accion: 'Accion',
      entidad: 'Entidad',
      reindexar: 'Reindexar Meilisearch',
    },
    empresa: {
      pills: {
        brand: 'Identidad y marca',
        regional: 'Regional',
        templates: 'Plantillas',
        governance: 'Gobernanza',
        auth: 'Autenticacion',
      },
      formatoFecha: 'Formato de fecha',
      proximamente: 'Funcionalidad en desarrollo. Proximamente disponible.',
    },
    plataforma: {
      pills: {
        modules: 'Modulos y plan',
        apps: 'V·IAnet Apps',
        plan: 'Plan & Limites',
      },
      appsTitle: 'V·IAnet Apps (M12)',
      appsDesc: 'Sub-apps del modulo M12 V·IAnet Apps. Solo se activan si M12 esta activo.',
      planCardTitle: 'Plan y limites del tenant',
      planLabel: 'Plan de licenciamiento',
      maxUsuariosLabel: 'Maximo de usuarios',
      dominioLabel: 'Dominio personalizado',
      dominioHint:
        'Vacio = usar dominio por defecto. Requiere DNS CNAME apuntando a app.valoriagovernance.com.',
      planSaveBtn: 'Guardar cambios',
      planSaving: 'Guardando...',
      planSaveOk: 'Plan y limites actualizados correctamente',
      planSaveErr: 'Error al guardar plan',
      appUpdateErr: 'Error al actualizar app',
    },
    ia: {
      pills: {
        status: 'Estado y consumo',
        config: 'Configuracion',
        chat: 'VALORIA Chat',
        assist: 'VALORIA Assist',
        providers: 'Proveedores',
        instructions: 'Instrucciones',
        evals: 'Evaluaciones',
      },
      sinDatos: 'Sin datos de consumo disponibles',
      proximamente: 'Funcionalidad en desarrollo. Proximamente disponible.',
      systemPrompt: 'System prompt personalizado',
      systemPromptPlaceholder: 'Instrucciones personalizadas para el asistente IA del tenant...',
      proveedores: {
        titulo: 'Proveedores y modelos',
        ayuda:
          '¿Qué proveedores de IA tiene disponibles el sistema?\n\nAquí configuras cada uno: su API key, la URL de conexión y el modelo que usará por defecto. La mayoría son servicios en la nube (Mistral, Groq, NVIDIA…), pero Ollama es especial: corre en tu propio ordenador, sin enviar datos al exterior.\n\nAntes de activar un proveedor, pulsa "Probar" para comprobar que la conexión funciona correctamente.',
      },
      chat: {
        titulo: 'Configuración del chat',
        ayuda:
          '¿Quién responde cuando haces una pregunta en V·IA?\n\nEl proveedor principal es el primero en intentarlo. Si falla o alcanza su límite de uso, el sistema pasa automáticamente al siguiente de la cadena de fallback, sin que el usuario note nada.\n\nEl botón "Reindexar" actualiza el índice de búsqueda RAG con los documentos más recientes publicados en el sistema.',
      },
      modos: {
        titulo: 'Modos de asistente',
        ayuda:
          'V·IA trabaja de forma diferente según lo que necesites:\n\n· Generación — crea contenido nuevo a partir de una instrucción.\n· Corrección — revisa y mejora un texto existente.\n· Auditoría — verifica el cumplimiento normativo de un documento.\n· Traducción — adapta el contenido a otro idioma.\n\nPuedes asignar un modelo distinto a cada modo para ajustar el equilibrio entre velocidad, coste y calidad.',
      },
      rag: {
        titulo: 'Estado del índice RAG',
        ayuda:
          '¿Qué es el índice RAG?\n\nEl sistema busca información en los documentos convirtiendo el texto en vectores matemáticos (embeddings). Este índice se genera una vez y se reutiliza en cada consulta.\n\n· "Solo cambios" — reindexar únicamente los documentos modificados desde el último indexado. Rápido y sin saturar la cuota de Gemini.\n· "Todo" — reindexar todos los documentos desde cero. Útil si sospechas que el índice está corrupto o incompleto.\n\nEl reindexado automático ocurre al arrancar el servidor y cada 30 minutos en segundo plano.',
        soloCambios: 'Solo cambios',
        todo: 'Todo',
        reindexar: 'Reindexar',
        indexando: 'Indexando...',
        ultimaIndexacion: 'Última indexación',
        autoCada: 'Reindexado automático cada',
        minutos: 'minutos',
        ultimosCiclos: 'Últimos reindexados',
      },
    },
    notificaciones: {
      titulo: 'Preferencias de Notificaciones',
      evento: 'Evento',
      email: 'Email',
      push: 'Push',
      inApp: 'In-App',
      guardar: 'Guardar preferencias',
      guardado: 'Preferencias de notificaciones guardadas',
      canales: {
        titulo: 'Canales de notificación',
        descripcion:
          'Configura proveedores de salida para que las etapas NOTIFICAR del workflow lleguen a destinatarios externos.',
        mailTitulo: 'Email (Resend)',
        mailDescripcion: 'Notificaciones por correo electrónico vía Resend',
        mailHabilitar: 'Habilitar email',
        mailFromEmail: 'Email remitente',
        mailApiKey: 'API key de Resend',
        teamsTitulo: 'Microsoft Teams',
        teamsHabilitar: 'Habilitar Teams',
        teamsWebhook: 'URL del webhook entrante',
        slackTitulo: 'Slack',
        slackHabilitar: 'Habilitar Slack',
        slackWebhook: 'URL del webhook entrante',
        modoSandbox: 'Modo sandbox (no envía, solo loguea)',
        modoSandboxDescripcion:
          'Cuando está activo, los providers loguean pero no envían. Útil para deploys seguros.',
        cambiar: 'Cambiar',
        limpiar: 'Limpiar',
        credencialGuardada: 'Credencial guardada',
        credencialAusente: 'Sin credencial',
        nuevoValor: 'Nuevo valor',
        guardado: 'Configuración guardada',
        errorGuardar: 'Error al guardar configuración',
        // ADR-027.3 (0658c): claves del botón "Probar canal" + audit trail inline
        test: {
          botonProbar: 'Probar canal',
          enviando: 'Enviando...',
          exito: '✓ Mensaje enviado correctamente',
          error: '✕ Error: {detalle}',
          mensajeEnviadoEn: 'Enviado a las {timestamp}',
          messageId: 'ID: {id}',
          reasonNoProvider: 'Credencial no configurada',
          reasonProviderError: 'Error del proveedor',
          reasonSandboxMode: 'Modo sandbox activo',
          confirmarTest:
            '¿Enviar mensaje de prueba al email del admin actual? Se enviará un mensaje real (bypassa modo sandbox).',
        },
      },
    },
    secciones: {
      usuarios: 'Usuarios',
      roles: 'Roles y Permisos',
      procesos: 'Procesos',
      modulos: 'Modulos',
      via: 'Inteligencia Artificial',
      configuracion: 'Configuracion',
      auditoria: 'Auditoria',
    },
    usuarios: {
      nombre: 'Nombre',
      email: 'Email',
      rol: 'Rol',
      estado: 'Estado',
      ultimoAcceso: 'Ultimo acceso',
      crear: '+ Nuevo usuario',
      editar: 'Editar',
      desactivar: 'Desactivar',
      activo: 'Activo',
      inactivo: 'Inactivo',
      sinUsuarios: 'Sin usuarios',
      gestionarUsuarios: 'Gestiona los usuarios del tenant',
      nuevoUsuario: 'Nuevo usuario',
      nombreCompleto: 'Nombre completo',
      crearUsuario: 'Crear usuario',
      creando: 'Creando...',
      emailNombreObligatorios: 'Email y nombre son obligatorios',
      creadoCorrectamente: 'Usuario creado correctamente',
      desactivado: 'Usuario desactivado',
      confirmarDesactivar: 'Se desactivara este usuario. Continuar?',
      creado: 'Creado',
      // 0577 + 0580 + 0583: nuevas claves admin/usuarios PRD-002
      cambiarRolTitulo: 'Cambiar rol de usuario',
      cambiarRolUsuarioLabel: 'Usuario',
      cambiarRolActual: 'Rol actual',
      cambiarRolNuevo: 'Nuevo rol',
      cambiarRolHelp:
        'Solo SUPERADMIN_PLATFORM puede asignar SUPERADMIN_PLATFORM. El backend valida.',
      guardarCambios: 'Guardar cambios',
      guardando: 'Guardando...',
      cancelar: 'Cancelar',
      readOnlyBanner: 'Vista de solo lectura. Tu rol no permite invitar ni modificar usuarios.',
      copyPasswordTitulo: 'Usuario creado - Copia la contrasena temporal',
      copyPasswordHelp:
        'El email automatico no esta configurado. Copia esta contrasena y entregasela al usuario {email} de forma segura. No se mostrara de nuevo.',
      copiar: 'Copiar',
      cerrar: 'Cerrar',
      passwordCopiada: 'Contrasena copiada al portapapeles',
      empresaReadOnly:
        'Vista de solo lectura. Tu rol no permite modificar la configuracion de la empresa.',
      iaReadOnly: 'Vista de solo lectura. Tu rol no permite modificar la configuracion de IA.',
      // 0586: link a Estructura para gestionar cargos del organigrama (NO RBAC)
      cargosOrganigramaInfo:
        'Los roles de gobernanza (cargos del organigrama corporativo) no son roles RBAC del sistema. Se gestionan en el modulo Estructura.',
      cargosOrganigramaLink: 'Ir a Estructura',
      // 0600 (cadena 0590-0599) — claves agregadas para self-modify, modal manage,
      // bulk, lockout, banner SUPERADMIN, etc.
      tuBadge: '(tu)',
      superadminTenantBanner:
        'Estas viendo solo los usuarios de tu tenant interno (VALOR·IA). Para gestionar usuarios de otros tenants ve a {link} y usa Impersonate.',
      superadminTenantBannerLink: 'Backoffice',
      gestionar: 'Gestionar',
      exportarCsv: 'Exportar CSV',
      exportando: 'Exportando...',
      importarCsv: 'Importar CSV',
      importando: 'Importando...',
      invitar: '+ Invitar',
      invitarTitulo: 'Invitar nuevo usuario',
      invitarRolLabel: 'Rol asignado',
      invitarEnviar: 'Enviar invitacion',
      enviando: 'Enviando...',
      noUsuariosSeleccionados: '0 usuarios',
      mostrandoCount: 'Mostrando {from}-{to} de {total}',
      porPagina: 'Por pagina:',
      // Modal manage
      modalDatosBasicos: 'Datos basicos',
      modalPermisos: 'Permisos y acceso',
      modalAcciones: 'Acciones',
      modalEmailHelp: 'El email no se puede cambiar desde aqui (afecta al login).',
      modalPersonaLabel: 'Persona del organigrama (M1 Structure)',
      modalSinVincular: '— Sin vincular —',
      modalUltimoAcceso: 'Ultimo acceso',
      modalSelfBanner:
        'No puedes cambiar tu propio rol ni desactivarte/eliminarte. Solo puedes editar nombre y persona vinculada.',
      modalAdminOwnerBanner:
        'TENANT_ADMIN no puede modificar a un TENANT_OWNER. Solo TENANT_OWNER o SUPERADMIN_PLATFORM pueden hacerlo.',
      // Acciones modal
      resetearContrasena: 'Resetear contrasena',
      eliminarUsuario: 'Eliminar usuario',
      // Lockout
      lockoutBloqueada: 'Cuenta bloqueada',
      lockoutIntentos: '{n} intento(s) fallido(s)',
      lockoutMaximo: 'Maximo 5 antes de bloqueo automatico de 15 min.',
      lockoutDesbloquearAuto: 'Desbloqueo automatico en {min} min.',
      lockoutTrasIntentos: 'Tras {n} intentos fallidos.',
      desbloquear: 'Desbloquear',
      // Bulk actions
      bulkSeleccionados: '{n} usuario(s) seleccionado(s)',
      bulkLimpiar: 'Limpiar',
      bulkActivar: 'Activar',
      bulkDesactivar: 'Desactivar',
      bulkEliminar: 'Eliminar',
      // Confirm modal mensajes
      confirmar: 'Confirmar',
      confirmActivar: 'Activar usuarios',
      confirmDesactivar: 'Desactivar usuarios',
      confirmEliminar: 'Eliminar usuarios',
      // Persona vinculada hint
      personaVinculadaCount: '{n} personas en el catalogo del tenant.',
    },
    roles: {
      titulo: 'Roles y Permisos',
      matrizPermisos: 'Matriz de permisos por rol del sistema RBAC',
      permiso: 'Permiso',
    },
    procesos: {
      titulo: 'Procesos',
      vistaGeneral: 'Vista general del mapa de procesos del tenant',
      total: 'Total',
      estrategicos: 'Estrategicos',
      operativos: 'Operativos',
      soporte: 'Soporte',
      activos: 'Activos',
      filtrar: 'Filtrar por:',
      todos: 'Todos',
      cargando: 'Cargando procesos...',
    },
    modulos: {
      titulo: 'Modulos',
      estadoModulos: 'Estado de los modulos V·IAnet del tenant',
      soloPlatformPuedeActivar:
        'Solo la plataforma VALOR·IA puede activar o desactivar modulos. Vista de solo lectura.',
      total: 'Total',
      activos: 'Activos',
      inactivos: 'Inactivos',
      cargando: 'Cargando modulos...',
      descriptions: {
        M1: 'Organigramas Interactivos',
        M2: 'Mapa de Procesos',
        M3: 'Flujogramas',
        M4: 'Gestión Documental',
        M5: 'Búsqueda Inteligente',
        M6: 'Control de Versiones y Aprobación',
        M7: 'Auditoría',
        M8: 'Administración y RBAC',
        M9: 'API de Inteligencia Artificial',
        M10: 'Asistente Virtual de Gobernanza',
        M11: 'Cuadros de Mando de Gobernanza',
        M12: 'Apps de Digitalización de Procesos',
        M13: 'Comunicación Interna',
        M14: 'Aplicación Móvil',
        M15: 'Firma Electrónica',
        M16: 'Solicitudes y Aprobaciones',
        M17: 'Notificaciones Multi-canal',
        M18: 'Soporte Multilingüe',
        M19: 'Gestión de Riesgos ISO 31000',
        M20: 'Helpdesk y Soporte Interno',
      },
      proximamente: 'Próximamente',
      activado: 'activado',
      desactivado: 'desactivado',
      requiere: 'requiere',
      dependeDe: 'depende de',
    },
    i18n: {
      titulo: 'Gestión de Idiomas',
      descripcion: 'Vista de las claves de traducción del sistema en los 3 idiomas soportados',
      clavesTotal: 'claves totales',
      sinTraducirEN: 'sin traducción EN',
      sinTraducirZH: 'sin traducción ZH',
      buscar: 'Buscar por clave o texto...',
      soloSinTraducir: 'Solo sin traducir',
      clave: 'Clave',
      falta: 'Falta',
      mostrando: 'Mostrando',
      sinResultados: 'Sin resultados',
    },
    via: {
      titulo: 'Inteligencia Artificial',
      configuracion: 'Configuracion de V·IA y consumo de tokens',
      proveedor: 'Proveedor IA',
      modelo: 'Modelo',
      consumo: 'Consumo de tokens',
      limite: 'Limite mensual',
      usados: 'Tokens usados',
      restantes: 'Tokens restantes',
      consumoMes: 'Consumo del mes actual',
      consumoHistorico: 'Consumo historico',
      configuracionModelos: 'Configuracion de modelos',
      proveedorTraducciones: 'Proveedor de traducciones',
      proveedorTraduccionesAuto: 'Automatico (Gemma local → fallback)',
      proveedorTraduccionesHint:
        'Se usara para traducir automaticamente los datos a EN y ZH cuando se crea o edita contenido.',
      apiKeyPropia: 'API Key propia (opcional)',
      apiKeyDescripcion:
        'Si se proporciona, se usara esta clave en lugar de la clave compartida de V·IANet.',
      guardarConfigIA: 'Guardar configuracion IA',
      configGuardada: 'Configuracion de IA guardada',
      cargando: 'Cargando configuracion IA...',
      utilizado: 'utilizado',
      temperatura: 'Temperatura',
      maxTokens: 'Max Tokens',
    },
    config: {
      titulo: 'Configuracion',
      descripcion: 'Configuracion del tenant, marca y modulos',
      identidadMarca: 'Identidad y Marca',
      general: 'General',
      modulos: 'Modulos',
      marca: 'Marca',
      nombreMarca: 'Nombre de Marca',
      fuente: 'Fuente tipografica',
      colores: 'Colores',
      primario: 'Primario',
      secundario: 'Secundario',
      acento: 'Acento',
      vistaPrevia: 'Vista previa',
      logos: 'Logos',
      logoPrincipal: 'Logo principal',
      logoHeader: 'Logo header',
      favicon: 'Favicon',
      guardarCambios: 'Guardar cambios',
      archivoActualizado: 'Archivo actualizado',
      configGuardada: 'Configuracion guardada',
      cargando: 'Cargando configuracion...',
      configuracionGeneral: 'Configuracion General',
      idioma: 'Idioma',
      zonaHoraria: 'Zona Horaria',
      dominio: 'Dominio personalizado',
      plan: 'Plan',
      modulosActivos: 'Modulos activos',
      guardarModulos: 'Guardar modulos',
      guardando: 'Guardando...',
      errorAlSubirArchivo: 'Error al subir archivo',
    },
    auditoria: {
      titulo: 'Auditoria',
      registroActividad: 'Registro de actividad del sistema',
      entidad: 'Entidad',
      accion: 'Accion',
      desde: 'Desde',
      hasta: 'Hasta',
      todas: 'Todas',
      fecha: 'Fecha',
      usuario: 'Usuario',
      evento: 'Evento',
      detalle: 'Detalle',
      cargando: 'Cargando...',
      sinRegistros: 'Sin registros',
      anterior: 'Anterior',
      siguiente: 'Siguiente',
      sistema: 'Sistema',
    },

    // 0658a — Plantillas notif workflow (ADR-027.1)
    workflow: {
      plantillas: {
        tituloEditor: 'Editor de plantillas',
        tabIn_app: 'In-app',
        tabEmail: 'Email',
        tabTeams: 'Teams',
        tabSlack: 'Slack',
        labelAsunto: 'Asunto',
        labelCuerpo: 'Cuerpo',
        idiomaEs: 'Espanol',
        idiomaEn: 'English',
        idiomaZh: 'Chino',
        variablesDisponibles: 'Variables disponibles',
        placeholderAsunto: 'Ej: Nueva edicion de {{artefactoTitulo}}',
        placeholderCuerpo: 'Cuerpo del mensaje. Usa {{variables}} para personalizar.',
        botonGuardar: 'Guardar plantilla',
        botonActiva: 'Plantilla activa',
        botonAnadirEditor: 'Editar plantillas',
        actionTooltipNotificar: 'Notificacion auto-procesada (no requiere aprobacion)',
        selectOptionRevisar: 'REVISAR',
        selectOptionAprobar: 'APROBAR',
        selectOptionNotificar: 'NOTIFICAR',
        cargando: 'Cargando...',
        cerrar: 'Cerrar',
      },
    },
  },

  // Tenant Selector
  tenantSelector: {
    subtitle: 'Seleccione la organizacion a la que desea acceder',
    selectTenant: 'Organizaciones disponibles',
  },

  // Onboarding Wizard
  onboarding: {
    steps: [
      'Bienvenida',
      'Datos empresa',
      'Logo y marca',
      'Usuarios iniciales',
      'Completado',
    ] as string[],
    stepLabel: (current: number, total: number) => `Paso ${current} de ${total}`,
    welcomeTitle: 'Bienvenido a V·IANet Governance',
    welcomeDesc:
      'En los siguientes pasos configuraremos su organizacion en la plataforma. Este asistente le guiara por los datos basicos, identidad visual y usuarios iniciales.',
    companyTitle: 'Datos de la empresa',
    companyName: 'Nombre de la empresa',
    companyNamePlaceholder: 'Mi Empresa S.A.',
    industry: 'Sector / Industria',
    industryPlaceholder: 'Tecnologia, Finanzas, Energia...',
    country: 'Pais',
    countryPlaceholder: 'Espana',
    employees: 'Empleados',
    brandTitle: 'Logo y marca',
    logo: 'Logo de la organizacion',
    dropLogo: 'Arrastre una imagen o haga clic para seleccionar',
    primaryColor: 'Color primario',
    secondaryColor: 'Color secundario',
    accentColor: 'Color acento',
    usersTitle: 'Usuarios iniciales',
    usersDesc:
      'Invite a los primeros usuarios de su organizacion. Podra añadir mas desde el panel de administracion.',
    email: 'Email',
    role: 'Rol',
    completeTitle: 'Configuracion completada',
    completeDesc:
      'Su organizacion esta lista. Puede comenzar a utilizar V·IANet Governance y configurar los modulos de gobernanza corporativa.',
    goToPanel: 'Ir al panel de administracion',
  },

  // Backoffice
  backoffice: {
    titulo: 'Backoffice — Gestion de Plataforma',
    gestionTenants: 'Tenants de la plataforma',
    descripcion:
      'Gestion centralizada de todas las organizaciones registradas en V·IANet Governance.',
    crearTenant: 'Crear tenant',
    usingPlaceholder: 'No se pudo conectar al servicio. Mostrando datos de ejemplo.',
    columns: {
      nombre: 'Nombre',
      plan: 'Plan',
      usuarios: 'Usuarios',
      docs: 'Documentos',
      estado: 'Estado',
      acciones: 'Acciones',
    },
    addAdmin: {
      btn: '+ Admin',
      btnEliminar: 'Eliminar',
      titulo: 'Añadir administrador a',
      subtitulo:
        'Se creará un usuario con rol CEO en este tenant. Recibirás una contraseña temporal para entregarla al administrador del cliente.',
      email: 'Email del administrador',
      emailPlaceholder: 'admin@empresa.com',
      nombre: 'Nombre completo',
      nombrePlaceholder: 'Juan Pérez',
      cancelar: 'Cancelar',
      crear: 'Crear administrador',
      creando: 'Creando…',
      exitoTitulo: '¡Administrador creado!',
      exitoDescripcion:
        'Copia la contraseña temporal y entrégasela al cliente. Por seguridad ya no podrás volver a verla.',
      passwordLabel: 'Contraseña temporal',
      copiarPassword: 'Copiar',
      copiado: '¡Copiado!',
      cerrar: 'Cerrar',
      confirmEliminarTitulo: '¿Eliminar tenant?',
      confirmEliminarDesc: (nombre: string) =>
        `Vas a eliminar "${nombre}" y todos sus datos (usuarios, configuración IA, auditoría). Esta acción NO se puede deshacer.`,
      confirmEliminarBtn: 'Sí, eliminar',
    },
    impersonate: {
      btn: 'Acceder como',
      banner: 'Estás suplantando {tenant} (sesión original: {email}) ·',
      bannerVolver: 'Volver a mi cuenta',
      confirmTitulo: '¿Acceder como administrador de este tenant?',
      confirmDesc: (nombre: string) =>
        `Vas a entrar en la cuenta del tenant "${nombre}" durante 1 hora. Toda acción quedará registrada en auditoría con tu identidad original.`,
      confirmBtn: 'Sí, acceder',
      error: 'No se pudo iniciar la sesión de impersonation.',
    },
    wizard: {
      titulo: 'Crear nuevo tenant',
      subtitulo: 'Completa los 3 pasos para registrar una nueva organización en la plataforma',
      step0Label: 'Identificación',
      step1Label: 'Configuración',
      step2Label: 'Marca',
      nombre: 'Nombre de la organización',
      nombrePlaceholder: 'Grupo Puentes, Acme Corp...',
      slugHint: 'Identificador único de la organización. Solo letras, números y guiones.',
      plan: 'Plan',
      maxUsuarios: 'Máx. usuarios',
      modulos: 'Módulos activos',
      modulosSeleccionados: 'módulos seleccionados',
      idioma: 'Idioma predeterminado',
      formatoFecha: 'Formato de fecha',
      zonaHoraria: 'Zona horaria',
      colorPrimario: 'Color primario',
      colorSecundario: 'Color secundario',
      colorAcento: 'Color acento',
      fuente: 'Fuente tipográfica',
      preview: 'Vista previa',
      exitoTitulo: '¡Tenant creado correctamente!',
      exitoDescripcion: 'La organización ha sido registrada en la plataforma.',
      volverBackoffice: 'Volver al backoffice',
      anterior: 'Anterior',
      siguiente: 'Siguiente',
      crear: 'Crear tenant',
      creando: 'Creando...',
    },
  },

  // Importar documento
  importar: {
    titulo: 'Importar Documento',
    descripcion: 'Suba un archivo .docx o .pdf para importar su contenido al sistema',
    arrastrar: 'Arrastre un archivo aqui o haga clic para seleccionar',
    oSeleccionar: 'Formatos admitidos: .docx, .pdf (max. 50 MB)',
    procesando: 'Procesando archivo...',
    previsualizacion: 'Previsualizacion',
    confirmar: 'Confirmar Importacion',
    cancelar: 'Cancelar',
    importando: 'Importando documento...',
    creandoDocumento: 'Creando documento, version y estructura en la base de datos',
    exito: 'Documento importado correctamente',
    importarOtro: 'Importar otro',
    verDocumento: 'Ver documento',
    reintentar: 'Reintentar',
    metadatos: 'Metadatos del Documento',
    codigo: 'Codigo',
    nombre: 'Nombre',
    tipoDocumental: 'Tipo Documental',
    proceso: 'Proceso',
    edicion: 'Edicion',
    archivo: 'Archivo',
    seleccione: 'Seleccione...',
    autoDetectar: 'Auto-detectar desde codigo',
    estructuraDetectada: 'Estructura Detectada',
    secciones: 'secciones',
    bloques: 'bloques',
    seccionVacia: '(seccion vacia)',
    advertencias: 'Advertencias',
    completarCampos: 'Complete todos los campos obligatorios',
    soloDocxPdf: 'Solo se admiten archivos .docx y .pdf',
    errorParsear: 'Error al parsear el archivo',
    errorConfirmar: 'Error al confirmar la importacion',
  },

  // Common
  common: {
    dictado: {
      dictar: 'Dictar',
      detener: 'Detener',
      transcribiendo: 'Transcribiendo…',
      noSoportado: 'Tu navegador no permite grabar audio',
      sinPermiso: 'Sin acceso al micrófono',
      error: 'No se pudo transcribir',
    },
    persona: {
      cargando: 'Cargando persona…',
      noEncontrada: 'Persona no encontrada',
      puestoUnknown: 'Sin puesto activo',
    },
    guardar: 'Guardar',
    cancelar: 'Cancelar',
    cerrar: 'Cerrar',
    eliminar: 'Eliminar',
    editar: 'Editar',
    crear: 'Crear',
    buscar: 'Buscar...',
    cargando: 'Cargando...',
    error: 'Error',
    exito: 'Exito',
    confirmar: 'Confirmar',
    volver: 'Volver',
    siguiente: 'Siguiente',
    anterior: 'Anterior',
    guardando: 'Guardando...',
    acciones: 'Acciones',
    ver: 'Ver',
    nombre: 'Nombre',
    tipo: 'Tipo',
    estado: 'Estado',
    codigo: 'Código',
    fecha: 'Fecha',
    searchPlaceholder: 'Buscar...',
    rejectionReason: 'Indique el motivo del rechazo...',
    documentName: 'Nombre del documento',
    nodeName: 'Nombre del nodo',
    nodeDescription: 'Descripción del nodo',
    noPhase: 'Sin fase',
    selectPosition: 'Seleccionar puesto...',
    selectDocument: 'Seleccionar documento...',
    selectProcess: 'Seleccionar proceso...',
    examplePolicy: 'Ej. Política de Calidad',
    processDescription: 'Descripción del proceso...',
    processScope: 'Alcance del proceso...',
    exampleChangelog:
      'Ej.: Actualización de la sección 5.3 para incorporar el nuevo flujo de aprobación...',
    processCode: 'Código del proceso (ej: PE.21)',
    companyName: 'Nombre de la empresa',
    exampleCode: 'PE.21.NC.01',
    basePath: 'C:\\Documentos\\Mapa de Procesos',
    conditionExample: 'ej: Aprobado?',
    descripcion: 'Descripción',
    enDesarrollo: 'Esta funcionalidad está en desarrollo',
    loadingDocument: 'Cargando documento...',
    documentNotFound: 'Documento no encontrado',
    discard: 'Descartar',
    closeEditor: 'Cerrar editor',
    newEditionBtn: '+ Nueva Ed.',
    documentSaved: 'Documento guardado',
    errorSaving: 'Error al guardar: ',
    changesDiscarded: 'Cambios descartados',
    statusUpdated: 'Estado actualizado correctamente',
    newEditionCreated: 'Nueva edición creada',
    errorNewEdition: 'Error al crear nueva edición',
    discardChanges: 'Descartar cambios',
    discardWarning:
      'Se perderán todos los cambios realizados desde la última vez que se guardó. Esta acción no se puede deshacer.',
    autoSave: 'Guardado automático:',
    noContent: 'Este documento no tiene contenido todavía.',
    processing: 'Procesando...',
    creating: 'Creando...',
    selectDocFromList: 'Selecciona un documento del listado para visualizarlo aquí',
    style: 'Estilo...',
    page: 'Pag.',
    nuevaEdicionBtn: '+ Nueva Edición',
    errorTransicion: 'Error en la transición',
    errorDescartar: 'Error al descartar cambios',
    errorCargarDocumento: 'Error al cargar el documento',
    errorDesconocido: 'Error desconocido',
    noTieneContenido: 'Este documento no tiene contenido todavía.',
    descartarCambiosDialogTitle: 'Descartar cambios',
    descartarCambiosDialogDesc:
      'Se perderán todos los cambios no guardados del editor. Esta acción no se puede deshacer.',
    accionNoValida: (accion: string, estado: string) =>
      `Acción "${accion}" no válida para el estado actual "${estado}"`,
    expandir: 'Expandir',
    negrita: 'Negrita',
    cursiva: 'Cursiva',
    titulo1: 'Titulo1',
    titulo2: 'Titulo2',
    titulo3: 'Titulo3',
    listaConVinetas: 'Lista con viñetas',
    listaNumerada: 'Lista numerada',
    insertarTabla: 'Insertar tabla',
    deshacer: 'Deshacer',
    rehacer: 'Rehacer',
    viaAsistente: 'V·IA Asistente',
    sinSeleccion: '--',
    pagination: {
      anterior: 'Anterior',
      siguiente: 'Siguiente',
      pageOf: (page: number, total: number) => `Pagina ${page} de ${total}`,
    },
    estados: {
      activo: 'Activo',
      inactivo: 'Inactivo',
    },
  },

  // Role labels
  roles: {
    CEO: 'Direccion General',
    COO: 'Direccion de Operaciones',
    CTO: 'Direccion Tecnologica',
  },

  // Structure module (M1)
  structure: {
    // Landing page
    title: 'Estructura Organizativa',
    description:
      'Organigramas, puestos, relaciones jerárquicas y funcionales. Define la arquitectura organizativa y los órganos de gobierno corporativo.',
    puestosTitle: 'Catálogo de puestos',
    personasTitle: 'Directorio de personas',
    tooltips: {
      departamentosArbol: {
        titulo: 'Estructura organizativa',
        ayuda:
          'Representa la jerarquía de unidades organizativas del tenant.\n\n· Haz clic en cualquier nodo para ver sus detalles y las personas asignadas.\n· Los nodos en gris corresponden a unidades inactivas.\n· La estructura refleja el modelo organizativo configurado en administración.',
      },
      adminPersonas: {
        titulo: 'Gestión de personas',
        ayuda:
          'Directorio de personas, puestos y roles del tenant.\n\nCada persona puede tener múltiples puestos. Los puestos pertenecen a roles funcionales que definen las responsabilidades en los procesos de gobernanza.\n\nLos cambios aquí afectan a los responsables asignados en procesos y documentos.',
      },
      puestos: {
        titulo: 'Catálogo de puestos',
        ayuda:
          'Listado de todos los puestos definidos en la organización.\n\nCada puesto pertenece a un rol funcional y puede tener una o varias personas asignadas. Los puestos son la unidad de asignación de responsabilidades en procesos y documentos.',
      },
      personas: {
        titulo: 'Directorio de personas',
        ayuda:
          'Todas las personas registradas en el sistema con sus puestos y departamentos.\n\nUsa los filtros para encontrar personas por departamento, rol o estado. Haz clic en una persona para ver su ficha completa con sus responsabilidades en procesos y documentos.',
      },
      glosario: {
        titulo: 'Glosario corporativo',
        ayuda:
          'Repositorio de términos y definiciones del sistema de gobernanza.\n\nLos términos del glosario se usan en documentos, procesos y fichas para garantizar un lenguaje común en toda la organización.',
      },
      misSolicitudes: {
        titulo: 'Mis solicitudes',
        ayuda:
          'Solicitudes que has creado o en las que participas como aprobador o involucrado.\n\nPuedes ver el estado de cada solicitud, los pasos pendientes y el histórico de acciones realizadas.',
      },
    },
    // FichaPersonalViewer (FP/FR)
    ficha: {
      tipoBadgeFP: 'FICHA DE PUESTO',
      tipoBadgeFR: 'FICHA DE ROL FUNCIONAL',
      guardando: 'Guardando…',
      guardado: 'Guardado ✓',
      sinRelaciones: '(Sin relaciones jerárquicas definidas)',
      sinRoles: '(Sin roles de gobernanza asignados)',
      workflow: {
        enviarRevision: 'Enviar a revisión',
        aprobar: 'Aprobar',
        iniciarFirma: 'Iniciar firma',
        iniciandoFirma: 'Iniciando firma…',
        reintentar: 'Reintentar',
        errorFirma: 'Error al iniciar firma',
        firmaSolicitada: 'Solicitud de firma enviada',
        firmaSolicitadaN: (n: number) => `Solicitud enviada a ${n} aprobador${n !== 1 ? 'es' : ''}`,
      },
    },
    descriptions: {
      orgChart: 'Visualiza y edita la estructura jerárquica de la organización',
      organizations: 'Gestiona las entidades del grupo corporativo',
      people: 'Directorio de personas y gestión de talento',
      governance: 'Análisis de gobernanza y órganos de dirección',
    },
    // Discipline tabs
    tabs: {
      orgChart: 'Organigrama',
      organizations: 'Organizaciones',
      people: 'Personas',
      governance: 'Gobernanza',
      analytics: 'Analytics',
      positions: 'Puestos',
      departments: 'Departamentos',
      admin: 'Administracion',
    },
    analytics: {
      title: 'People Analytics',
      comingSoon: 'Disponible en proxima version',
      tabs: { governance: 'Gobernanza', business: 'Negocio' },
      governance: {
        coverageRate: 'Cobertura de roles',
        vacancies: 'Vacantes',
        criticalVacancies: 'con roles criticos',
        activeRoles: 'Roles activos',
        inPositions: 'en puestos',
        busFactor: 'Bus factor',
        personsMultiRole: 'personas con 2+ roles',
        jobDescriptions: 'Fichas de puesto',
        completed: 'completadas',
        occupancyRate: 'Tasa de ocupacion',
        withoutPosition: 'Sin puesto',
        departments: 'Departamentos',
        withActivePeople: 'con personas activas',
        roleConcentration: 'Concentracion de roles (bus factor)',
        rolesByType: 'Roles de gobernanza por tipo',
        coverageByLevel: 'Cobertura por nivel jerarquico',
        alerts: 'Alertas de gobernanza',
        detailTable: 'Detalle de personas',
        clearFilters: 'Limpiar filtros',
        activeFilters: 'Filtros activos',
        noResults: 'No se encontraron personas con los filtros aplicados.',
        noData: 'Sin datos',
        noDataDesc: 'No hay datos de gobernanza disponibles.',
        fichasPuesto: 'Fichas de puesto',
        noPuesto: 'Personas sin puesto',
        busFactorChart: 'Concentracion de roles (bus factor)',
        loading: 'Cargando datos de gobernanza...',
        error: 'Error al cargar datos de gobernanza.',
      },
      business: {
        title: 'Negocio',
        totalPeople: 'Personas activas',
        recentHires: 'ultimos 3 meses',
        evolution: 'Evolucion de incorporaciones',
        monthlyHires: 'Altas mensuales',
        cumulative: 'Acumulado',
        companies: 'Empresas',
        sites: 'Centros',
        positions: 'Puestos',
        countries: 'Paises',
        departments: 'Direcciones',
        byDepartment: 'Empleados por direccion',
        byPosition: 'Empleados por puesto',
        byCompany: 'Por empresa',
        bySite: 'Por centro de trabajo',
        byCountry: 'Por pais',
        directory: 'Directorio',
        filters: 'Filtros',
        clearFilters: 'Limpiar filtros',
      },
      unified: {
        title: 'People Analytics',
        loading: 'Cargando People Analytics...',
        coverageRoles: 'Cobertura',
        vacancies: 'Vacantes',
        busFactor: 'Bus factor',
        activeRoles: 'Roles',
        jobDescriptions: 'Fichas',
        occupancy: 'Ocupacion',
        activePeople: 'Personas',
        companies: 'Empresas',
        positions: 'Puestos',
        departments: 'Direcciones',
        countries: 'Paises',
        recentHires: 'Altas 3m',
        busFactorChart: 'Bus factor',
        rolesByType: 'Roles por tipo',
        evolution: 'Evolucion',
        byDepartment: 'Por direccion',
        coverageByLevel: 'Cobertura nivel',
        alerts: 'Alertas',
        vacancyDistribution: 'Vacantes',
        byCompany: 'Por empresa',
        bySite: 'Por centro',
        byCountry: 'Por pais',
        detailTable: 'Directorio de personas',
        clearFilters: 'Limpiar filtros',
        superior: 'Superior',
        byPosition: 'Por puesto',
      },
    },
    // Org chart
    orgChart: {
      title: 'Organigrama Corporativo',
      vertical: 'Vertical',
      horizontal: 'Horizontal',
      exportPdf: 'Exportar PDF',
      exporting: 'Exportando...',
      fullscreen: 'Pantalla completa',
      exitFullscreen: 'Salir',
      editOrgChart: 'Editar organigrama',
      saveAndExit: 'Guardar y salir',
      discardChanges: 'Descartar cambios',
      discardChangesConfirm:
        '¿Descartar todos los cambios del organigrama? Esta acción no se puede deshacer.',
      closeEditMode: 'Cerrar',
      loadingOrgChart: 'Cargando organigrama...',
      editMode: 'EDICION',
      editHelp:
        'Arrastra nodos para moverlos. Conecta handles para crear relaciones. Click derecho para mas opciones.',
      resetLayout: 'Restablecer layout automatico',
      backToFull: 'Volver al organigrama completo',
      newPuesto: '+ Nuevo puesto',
      totalPuestos: 'Total puestos',
      vacantes: 'Vacantes',
      personasAsignadas: 'Personas asignadas',
      editModeActive: 'Modo edicion activo',
      semanticZoom: 'Zoom semantico',
      errorLoadPuesto: 'Error al cargar puesto',
      close: 'Cerrar',
      viewPersonProfile: 'Ver ficha completa',
      layerNone: 'Sin capa',
      layerGovernance: 'Roles de gobernanza',
      layerVacancies: 'Vacantes',
      layerLevels: 'Niveles',
      legend: 'Leyenda',
      vacantCritical: 'Vacante con rol critico',
      viewInOrgChart: 'Ver en organigrama',
      searchPlaceholder: 'Buscar persona o puesto...',
      legendNiveles: 'Niveles',
      noResults: 'Sin resultados',
      // 0651: strings WorkflowBar + visor organigrama (migrados de hardcoded).
      loadingWorkflow: 'Cargando workflow…',
      historyVersions: 'Historial de versiones',
      noVersionsYet: 'No hay versiones aún.',
      viewHistory: 'Ver historial de versiones',
      historyButton: (n: number) => `Historial (${n})`,
      editionNumber: (n: number) => `Edición ${n} del organigrama`,
      editButtonDisabledTooltip:
        'Crea una nueva edición primero — solo puedes editar versiones en BORRADOR.',
    },
    // Detail drawer
    drawer: {
      info: 'Informacion',
      nivel: 'Nivel',
      departamento: 'Departamento',
      organizacion: 'Organizacion',
      assignedPerson: 'Persona asignada',
      vacant: 'Vacante',
      chainOfCommand: 'Cadena de mando',
      subordinates: 'Subordinados',
      moreItems: (n: number) => `+${n} mas...`,
      governanceRoles: 'Roles de gobernanza',
      viewFicha: 'Ver ficha de puesto',
      noFicha: 'Sin ficha',
      viewInOrgChart: 'Ver en organigrama',
    },
    fichaLabel: 'Ficha',
    // Context menu & floating toolbar
    editPuesto: 'Editar puesto',
    assignPerson: 'Asignar persona',
    createSubordinate: 'Crear subordinado',
    createRelation: 'Crear relacion',
    deletePuesto: 'Eliminar puesto',
    confirmDeletePuesto:
      'Esta seguro de que desea eliminar este puesto? Esta accion no se puede deshacer.',
    errorDeletePuesto: 'Error al eliminar puesto',
    // Edge popover
    deleteRelation: 'Eliminar relacion',
    // Relation modal
    newRelation: 'Nueva relacion',
    relationType: 'Tipo de relacion',
    solidRelation: 'Solida (jerarquica directa)',
    dottedRelation: 'Punteada (reporte indirecto)',
    functionalRelation: 'Funcional',
    projectRelation: 'Proyecto (temporal)',
    isPrimaryRelation: 'Es relacion principal',
    createRelationBtn: 'Crear relacion',
    // Create puesto modal
    newPuestoTitle: 'Nuevo puesto',
    titleRequired: 'El titulo es obligatorio',
    errorCreatePuesto: 'Error al crear puesto',
    tituloLabel: 'Titulo',
    codigoLabel: 'Codigo',
    nivelLabel: 'Nivel',
    organizacionLabel: 'Organizacion',
    departamentoLabel: 'Departamento',
    reportsToLabel: 'Reporta a',
    assignedPersonLabel: 'Persona asignada (opcional)',
    selectOption: 'Seleccionar',
    noneOption: 'Ninguno',
    noAssignment: 'Sin asignar',
    creating: 'Creando...',
    createPuesto: 'Crear puesto',
    // Person selector modal
    assignPersonTitle: 'Asignar persona',
    puestoLabel: 'Puesto',
    searchByNameOrEmail: 'Buscar por nombre o email...',
    noResults: 'Sin resultados',
    errorAssignPerson: 'Error al asignar persona',
    // PuestoNode
    vacantLabel: 'Vacante',
    ocupadoLabel: 'Ocupado',
    soloVacantes: 'Solo vacantes',
    // Puesto detail page
    puestoDetail: {
      loading: 'Cargando puesto...',
      notFound: 'Puesto no encontrado',
      goBack: 'Volver',
      viewInOrgChart: 'Ver en organigrama',
      fichaTitle: 'Ficha de puesto',
      openDocument: 'Abrir documento',
      noFicha: 'Este puesto no tiene ficha de caracterización asociada.',
      createFicha: 'Crear ficha de puesto',
      creatingFicha: 'Creando...',
    },
    // Organizaciones
    orgs: {
      title: 'Organizaciones',
      newOrg: '+ Nueva Organizacion',
      loadingOrgs: 'Cargando organizaciones...',
      noOrgs: 'No hay organizaciones registradas.',
      editOrg: 'Editar Organizacion',
      newOrgTitle: 'Nueva Organizacion',
      name: 'Nombre',
      shortName: 'Nombre corto',
      type: 'Tipo',
      departments: 'Departamentos',
      positions: 'Puestos',
      status: 'Estado',
      active: 'Activa',
      inactive: 'Inactiva',
      view: 'Ver',
      nameRequired: 'El nombre es obligatorio',
      confirmDeleteOrg:
        'Eliminar esta organizacion? Se eliminaran todos sus departamentos y puestos.',
      holding: 'Holding',
      empresa: 'Empresa',
      filial: 'Filial',
      sucursal: 'Sucursal',
      division: 'Division',
      unidadNegocio: 'Unidad de Negocio',
      ute: 'UTE',
      jointVenture: 'Joint Venture',
      concesion: 'Concesion',
      // Detail view
      back: 'Volver',
      departmentTab: (n: number) => `Departamentos (${n})`,
      positionTab: (n: number) => `Puestos (${n})`,
      newDept: '+ Nuevo Departamento',
      editDept: 'Editar Departamento',
      newDeptTitle: 'Nuevo Departamento',
      parentDept: 'Departamento padre',
      noneRoot: 'Ninguno (nivel raiz)',
      noDepts: 'Sin departamentos',
      confirmDeleteDept: 'Eliminar este departamento?',
      newPosition: '+ Nuevo Puesto',
      editPosition: 'Editar Puesto',
      newPositionTitle: 'Nuevo Puesto',
      superior: 'Superior',
      none: 'Ninguno',
      noDept: 'Sin departamento',
      noPositions: 'Sin puestos',
      confirmDeletePosition: 'Eliminar este puesto?',
      person: 'Persona',
      parentOrg: 'Organizacion matriz',
      nifCif: 'NIF / CIF',
      country: 'Pais',
      parentOrgLabel: 'Matriz',
      subsidiaries: 'Filiales',
      vistaArbol: 'Arbol',
      vistaTabla: 'Tabla',
    },
    // Gobernanza
    governance: {
      title: 'Analisis de Gobernanza',
      vacanciesTab: 'Vacantes',
      matrixTab: 'Matriz de Responsabilidad',
      impactTab: 'Analisis de Impacto',
      vacanciesCount: (n: number) => `${n} puesto(s) sin persona asignada`,
      noVacancies: 'No hay vacantes. Todos los puestos estan cubiertos.',
      matrixDesc: (procs: number, puestos: number) =>
        `${procs} procesos × ${puestos} puestos responsables`,
      errorLoadMatrix: 'No se pudo cargar la matriz de responsabilidad.',
      noDataMatrix: 'No hay datos suficientes para la matriz de responsabilidad.',
      processCol: 'Proceso',
      selectPuesto: 'Seleccionar puesto para analisis',
      selectPuestoPlaceholder: 'Seleccionar puesto...',
      analyzing: 'Analizando...',
      analyzeImpact: 'Analizar Impacto',
      analyzedPuesto: 'Puesto analizado',
      directSubordinates: (n: number) => `Subordinados directos (${n})`,
      affectedProcesses: (n: number) => `Procesos afectados (${n})`,
      affectedDocuments: (n: number) => `Documentos afectados (${n})`,
      governanceRoles: (n: number) => `Roles de gobernanza (${n})`,
      noSubordinates: 'Sin subordinados',
      noProcesses: 'Sin procesos vinculados',
      noDocuments: 'Sin documentos vinculados',
      impactHint:
        "Seleccione un puesto y pulse 'Analizar Impacto' para ver el analisis completo de la eliminacion de ese puesto.",
      titulo: 'Titulo',
      persona: 'Persona',
      noGovernanceRoles: 'Sin roles de gobernanza asignados',
      actions: 'Acciones',
      viewInOrgChart: 'Ver en organigrama',
      // Organos de Gobierno (F2.10+F2.11+F2.12)
      organosTab: 'Órganos de Gobierno',
      organosEmpty: 'No hay órganos de gobierno registrados',
      organosLoading: 'Cargando órganos...',
      organosErrorLoad: 'No se pudieron cargar los órganos de gobierno',
      miembrosActivos: (n: number) =>
        `${n} miembro${n !== 1 ? 's' : ''} activo${n !== 1 ? 's' : ''}`,
      sinMiembros: 'Sin miembros registrados',
      estadoActivo: 'Activo',
      estadoCesado: 'Cesado',
      cargoCol: 'Cargo',
      nombreCol: 'Nombre',
      desdeCol: 'Desde',
      hastaCol: 'Hasta',
      estadoCol: 'Estado',
    },
    admin: {
      title: 'Administracion',
      personas: 'Personas',
      puestos: 'Puestos',
      departamentos: 'Departamentos',
      roles: 'Roles de gobernanza',
      organizaciones: 'Organizaciones',
      centros: 'Centros',
      niveles: 'Niveles',
      catalogos: 'Catalogos',
      usuarios: 'Usuarios ↔ Personas',
      glosario: 'Glosario',
      organos: 'Órganos de Gobierno',
      newPerson: 'Nueva persona',
      editPerson: 'Editar persona',
      newPosition: 'Nuevo puesto',
      editPosition: 'Editar puesto',
      newDepartment: 'Nuevo departamento',
      editDepartment: 'Editar departamento',
      newRole: 'Nuevo rol',
      newOrganization: 'Nueva organizacion',
      newSite: 'Nuevo centro',
      newLevel: 'Nuevo nivel',
      newCatalog: 'Nuevo catalogo',
      // 0455 — admin top-level
      activo: 'Activo',
      inactivo: 'Inactivo',
      // 0458 — barrido i18n fase 2: textos de columnas de tabla
      acciones: 'Acciones',
      fichaFR: 'Ficha FR',
      // 0473 — homogeneizacion RF / RG (texto de botones y toggle comunes)
      mostrarInactivos: 'Mostrar inactivos',
      fichaCrear: 'Crear FR',
      fichaVer: 'Ver FR',
      rolesContador: 'roles',
      // 0461 — barrido i18n fase 3: cabeceras/labels residuales (estado ya existe mas abajo)
      tipo: 'Tipo',
      nif: 'NIF',
      cargo: 'Cargo',
      desde: 'Desde',
      hasta: 'Hasta',
      entidad: 'Entidad',
      miembros: 'Miembros',
      // 0457 — tooltips genericos reutilizables entre admin components
      tooltips: {
        editar: 'Editar',
        desactivar: 'Desactivar',
        cesar: 'Cesar',
        eliminar: 'Eliminar',
        fichaAsignada: 'FR asignada',
        sinFichaRol: 'Sin FR',
        verFichaRol: 'Ver ficha FR',
        toggleActivar: 'Activar',
        toggleDesactivar: 'Desactivar',
        rolPlataforma: 'Rol de plataforma',
        desactivarOrgano: 'Desactivar órgano',
        cesarMiembro: 'Cesar miembro',
        eliminarMiembro: 'Eliminar miembro',
        // 0471 M12 — tooltips didácticos por tab Admin (shell compartido)
        adminPersonas: {
          titulo: 'Directorio de personas',
          ayuda:
            'Catálogo de personas físicas del tenant. Incluye empleados, colaboradores y externos con trazabilidad de puesto, departamento y estado laboral.\n\nCada persona puede tener varios puestos. Los cambios aquí se reflejan en los responsables asignados en procesos, documentos y órganos.',
        },
        adminPuestos: {
          titulo: 'Catálogo de puestos',
          ayuda:
            'Registro de los puestos definidos en la organización. Cada puesto pertenece a un rol funcional, un departamento y una organización, y puede tener varias personas asignadas en el tiempo.\n\nLos puestos son la unidad mínima de asignación de responsabilidades en procesos y documentos.',
        },
        adminDepartamentos: {
          titulo: 'Departamentos',
          ayuda:
            'Unidades organizativas en las que se estructura la organización. Cada departamento pertenece a una organización, puede tener un departamento padre (jerarquía) y un puesto responsable.\n\nEl tipo de unidad (configurable por tenant) clasifica el departamento en Direcciones, Áreas, Unidades, Equipos, etc.',
        },
        adminNivelesPuesto: {
          titulo: 'Niveles de puesto',
          ayuda:
            'Catálogo de niveles jerárquicos de puesto (Junior, Senior, Manager, Director, etc.). Cada puesto se asigna a un nivel, que determina la escala retributiva, la complejidad de responsabilidades y la ruta de carrera.\n\nReordena los niveles con las flechas para reflejar la progresión profesional dentro de la organización.',
        },
        adminRolesFuncionales: {
          titulo: 'Roles funcionales',
          ayuda:
            'Catálogo de roles funcionales de la organización. Describen las funciones, competencias y responsabilidades que un puesto debe cumplir.\n\nCada puesto hereda de un rol funcional. La ficha FR del rol actúa como plantilla de referencia para las fichas de puesto (FP).',
        },
        adminRolesGobernanza: {
          titulo: 'Roles de gobernanza',
          ayuda:
            'Catálogo de roles de gobernanza del tenant (DPO, Oficial de Cumplimiento, Propietario de Riesgo, etc.) con su puesto asignado y ficha FG.\n\nDistingue entre roles globales y roles por proceso (se gestionan desde la ficha del proceso). Los roles de sistema no se pueden eliminar.',
        },
        adminTiposUnidad: {
          titulo: 'Tipos de unidad organizativa',
          ayuda:
            'Catálogo configurable de tipos de unidad organizativa por tenant. Se usan para clasificar departamentos: Dirección, Área, Unidad, Equipo, etc.\n\nNo se puede eliminar un tipo si tiene departamentos asociados. Se ordenan por el campo Orden en organigramas y selectores.',
        },
        adminCatalogos: {
          titulo: 'Catálogos',
          ayuda:
            'Catálogos auxiliares configurables por tenant (tipos de contrato, categorías laborales, tipos de centro, etc.).\n\nCada catálogo define valores permitidos para formularios y listados. Los catálogos de sistema no se pueden eliminar; los personalizados sí, salvo que tengan registros asociados.',
        },
        adminCentros: {
          titulo: 'Centros',
          ayuda:
            'Registro de centros físicos y sedes del tenant (oficinas, plantas, almacenes, delegaciones).\n\nCada centro pertenece a una organización y guarda dirección, contacto y geolocalización. Se usa en asignaciones de puestos, proyectos y procesos con ámbito territorial.',
        },
        adminOrganos: {
          titulo: 'Órganos de gobierno',
          ayuda:
            'Órganos de gobierno del tenant (Consejo de Administración, Comité de Dirección, Comisión de Auditoría, etc.) con sus miembros y cargos.\n\nCada órgano pertenece a una entidad del grupo y tiene un histórico de altas y ceses de miembros para cumplir con los requisitos de trazabilidad.',
        },
        adminOrganizaciones: {
          titulo: 'Organizaciones',
          ayuda:
            'Entidades jurídicas del grupo corporativo (sociedades, UTE, sucursales). Se organizan en árbol societario con participaciones entre sociedades.\n\nCada organización tiene su NIF, domicilio social y relación con otras entidades. Es la raíz de la estructura organizativa para puestos, centros y procesos.',
        },
        adminGlosario: {
          titulo: 'Glosario corporativo',
          ayuda:
            'Repositorio de términos y definiciones del sistema de gobernanza. Los términos del glosario se usan en documentos, procesos y fichas para garantizar un lenguaje común en toda la organización.\n\nCada término puede tener sinónimos, categoría y marca de no-traducible para nombres propios o siglas técnicas.',
        },
        adminUsuariosPersonas: {
          titulo: 'Usuarios ↔ Personas',
          ayuda:
            'Vincula cada usuario de la plataforma con su ficha de persona en el directorio.\n\nLa vinculación es necesaria para que el usuario aparezca como responsable en procesos, documentos y órganos de gobierno. También permite asignar el rol de plataforma (admin, editor, lector) al usuario.',
        },
        adminTiposContrato: {
          titulo: 'Tipos de contrato',
          ayuda:
            'Catálogo de tipos de contrato laboral configurables por tenant (Indefinido, Temporal, Prácticas, Mercantil, etc.).\n\nSe asignan a las personas en sus datos laborales. No se puede desactivar un tipo si hay personas activas con él.',
        },
        adminCategoriasLaborales: {
          titulo: 'Categorías laborales',
          ayuda:
            'Catálogo de categorías laborales configurables por tenant (Técnico, Administrativo, Directivo, etc.) según convenio colectivo aplicable.\n\nSe asignan a las personas en sus datos laborales. No se puede desactivar una categoría si hay personas activas con ella.',
        },
      },
      // 0471 M12 — columnas compartidas entre admin components
      columns: {
        codigo: 'Código',
      },
      // 0457 — placeholders por componente admin
      organosPlaceholders: {
        nombre: 'Consejo de Administración de...',
        cargo: 'Administrador Único, Consejero, Secretario...',
      },
      departamentosPlaceholders: {
        codigo: 'Ej: DEP-001',
      },
      usuariosPlaceholders: {
        busqueda: 'Buscar por nombre, codigo o email...',
      },
      // 0455 — claves del modal de nivel de puesto
      nivelModal: {
        title: 'Nivel de puesto',
        errorRequired: 'Codigo y nombre obligatorios',
      },
      // 0455 — panel de rol funcional (2 tabs: Datos + Ficha Tiptap)
      rolFuncionalPanel: {
        nuevoRol: 'Nuevo rol funcional',
        tabDatos: 'Datos',
        tabFicha: 'Ficha',
        fichaDeshabilitada: 'Guarda primero los datos basicos',
        cancelar: 'Cancelar',
        guardar: 'Guardar',
        saving: 'Guardando...',
        fichaNoExiste: 'Este rol no tiene ficha FR asociada.',
        crearFicha: 'Crear ficha de rol funcional',
        creandoFicha: 'Creando...',
        fichaCreada: 'Ficha creada',
        fichaGuardada: 'Ficha guardada',
        errorCargarFicha: 'Error al cargar la ficha',
        fichaMision: 'Mision del rol',
        fichaFunciones: 'Funciones y responsabilidades',
        fichaCompetenciasTecnicas: 'Competencias tecnicas',
        fichaCompetenciasTransversales: 'Competencias transversales',
        fichaFormacion: 'Formacion requerida',
        fichaExperiencia: 'Experiencia requerida',
        fichaCertificaciones: 'Certificaciones obligatorias',
        fichaCondiciones: 'Condiciones del rol',
      },
      noPermission: 'No tienes permisos para acceder a esta seccion',
      organizations: 'Organizaciones',
      sites: 'Centros',
      levels: 'Niveles de puesto',
      catalogs: 'Catalogos',
      // AdminPuestos columnas y filtros (B·I18N.3 — 394)
      colCodigo: 'Código',
      colTitulo: 'Título',
      colDescripcion: 'Descripción',
      catalogosContador: 'catalogos',
      glosarioContador: 'terminos',
      tuoContador: 'tipos de unidad',
      departamentosContador: 'departamentos',
      organizacionesContador: 'organizaciones',
      organosContador: 'organos',
      colNivel: 'Nivel',
      colDepartamento: 'Departamento',
      colOrganizacion: 'Organización',
      colPlantilla: 'Plantilla',
      colVacante: 'Vacante',
      colVacantes: 'Vacantes',
      // AdminPersonas columnas extra (prompt 450)
      personasTitle: 'Personas',
      newPersona: 'Nueva persona',
      colNombre: 'Nombre',
      colEmail: 'Email',
      colTipo: 'Tipo',
      colEstado: 'Estado',
      colPuesto: 'Puesto',
      countLabel: 'personas',
      todosLosNiveles: 'Todos los niveles',
      todosLosDepartamentos: 'Todos los departamentos',
      nuevoPuesto: 'Nuevo puesto',
      vacanteSingular: (n: number) => `${n} vacante`,
      vacantesPluralN: (n: number) => `${n} vacantes`,
      countPuestos: 'puestos',
      sections: {
        identification: 'Identificacion',
        contact: 'Contacto',
        employment: 'Datos laborales',
        organization: 'Organizacion',
        notes: 'Observaciones',
        levels: 'Niveles de puesto',
      },
      save: 'Guardar',
      cancel: 'Cancelar',
      saved: 'Guardado correctamente',
      error: 'Error al guardar',
      confirmDeactivate: 'Confirmar baja de esta persona?',
      search: 'Buscar...',
      noResults: 'Sin resultados',
      required: 'Campo obligatorio',
      vacante: 'Vacante',
      ocupado: 'Ocupado',
      comingSoon: 'Proximamente',
      linkUser: 'Vincular',
      unlinkUser: 'Desvincular',
      notLinked: '(sin vincular)',
      linked: 'Vinculado',
      // Tipos de unidad organizativa
      tiposUnidad: 'Tipos de Unidad',
      newTipoUnidad: 'Nuevo tipo de unidad',
      editTipoUnidad: 'Editar tipo de unidad',
      nombreCorto: 'Nombre corto',
      orden: 'Orden',
      color: 'Color',
      esDefault: 'Por defecto',
      cantDeleteTipoConDeptos: 'No se puede eliminar: tiene departamentos asociados',
      confirmDeleteTipo: 'Eliminar este tipo de unidad organizativa?',
      // Roles funcionales
      rolesFuncionales: 'Roles Funcionales',
      newRolFuncional: 'Nuevo rol funcional',
      editRolFuncional: 'Editar rol funcional',
      descripcion: 'Descripcion',
      nivelMinimo: 'Nivel minimo',
      nivelMaximo: 'Nivel maximo',
      puestosAsociados: 'Puestos',
      confirmDeactivateRol: 'Desactivar este rol funcional?',
      rolFuncional: 'Rol funcional',
      // Centros campos completos
      direccion: 'Direccion',
      codigoPostal: 'Codigo Postal',
      provincia: 'Provincia',
      pais: 'Pais',
      telefono: 'Telefono',
      personaContacto: 'Persona de contacto',
      latitud: 'Latitud',
      longitud: 'Longitud',
      urlUbicacion: 'Enlace de ubicacion (Google Maps)',
      estado: 'Estado',
      // Niveles edicion
      editNivel: 'Editar nivel',
      colorFondo: 'Color de fondo',
      // Roles gobernanza mejorado
      conflictoIndependencia: 'Conflicto de independencia',
      sinConflictos: 'Sin conflictos',
      puestoAsignado: 'Puesto asignado',
      personaEnPuesto: 'Persona en el puesto',
      sinPuestoAsignado: 'Sin puesto asignado',
      // Usuarios-Personas
      rolPlataforma: 'Rol de plataforma',
      gestionarAcceso: 'Gestionar acceso',
      usuarioVinculado: 'Usuario vinculado',
      sinUsuarioVinculado: 'Sin usuario vinculado',
      personaPanel: {
        sinUsuario: 'Esta persona no tiene usuario asociado.',
        usuario: {
          email: 'Email',
          rol: 'Rol',
          estado: 'Estado',
        },
      },
      tiposContrato: {
        label: 'Tipos de Contrato',
        title: 'Tipos de Contrato',
        newItem: 'Nuevo tipo de contrato',
        editItem: 'Editar tipo de contrato',
        columns: {
          codigo: 'Codigo',
          nombre: 'Nombre',
          descripcion: 'Descripcion',
          activo: 'Activo',
          acciones: 'Acciones',
        },
        placeholders: {
          nombre: 'Ej. Indefinido',
          descripcion: 'Descripcion opcional',
        },
        confirmDeactivate: 'Desactivar este tipo de contrato?',
        enUso: 'No se puede desactivar: hay personas activas con este tipo',
        itemLabel: 'tipos de contrato',
      },
      categoriasLaborales: {
        label: 'Categorias Laborales',
        title: 'Categorias Laborales',
        newItem: 'Nueva categoria laboral',
        editItem: 'Editar categoria laboral',
        columns: {
          codigo: 'Codigo',
          nombre: 'Nombre',
          descripcion: 'Descripcion',
          activo: 'Activo',
          acciones: 'Acciones',
        },
        placeholders: {
          nombre: 'Ej. Tecnico',
          descripcion: 'Descripcion opcional',
        },
        confirmDeactivate: 'Desactivar esta categoria laboral?',
        enUso: 'No se puede desactivar: hay personas activas con esta categoria',
        itemLabel: 'categorias laborales',
      },
      // Organizaciones arbol
      participacionEnPadre: '% Participacion',
      arbolSocietario: 'Arbol societario',
      vistaArbol: 'Arbol',
      vistaTabla: 'Tabla',
      // Enum labels — TipoPersona
      tipoPersonaEmpleado: 'Empleado',
      tipoPersonaColaborador: 'Colaborador',
      tipoPersonaExterno: 'Externo',
      // Enum labels — EstadoPersona
      estadoActivo: 'Activo',
      estadoBaja: 'Baja',
      estadoSuspendido: 'Suspendido',
      // Enum labels — TipoCosto
      tipoCostoOperaciones: 'Operaciones',
      tipoCostoEstructuraProyecto: 'Estructura de proyecto',
      tipoCostoEstructuraCorporativa: 'Estructura corporativa',
      // Roles de gobernanza — sub-namespace (prompt 399)
      rolesGobernanza: {
        title: 'Roles de gobernanza',
        newRol: 'Nuevo rol',
        search: 'Buscar...',
        noResults: 'Sin resultados',
        colNombre: 'Nombre personalizado',
        colActivo: 'Activo',
        colAccion: 'Acción',
        saved: 'Guardado correctamente',
        countLabel: 'roles',
        sistema: 'Sistema',
        verFichaFG: 'Ver ficha FG',
        verFichaTitle: 'Ver Ficha de Rol de Gobernanza',
        vacante: 'Vacante',
        activo: 'Activo',
        inactivo: 'Inactivo',
        rolSistema: 'Rol de sistema',
        desactivar: 'Desactivar',
        activar: 'Activar',
        rolActivado: 'Rol activado',
        rolDesactivado: 'Rol desactivado',
        errorCambiarEstado: 'Error al cambiar estado',
        colPuestoAsignado: 'Puesto asignado',
        colPersonaEnPuesto: 'Persona en el puesto',
        tipoRol: {
          REPRESENTANTE_PROCESO: 'Representante del proceso',
          DIRECCION_RESPONSABLE_PROCESO: 'Dirección responsable del proceso',
          DPO: 'Delegado de Protección de Datos',
          OFICIAL_CUMPLIMIENTO: 'Oficial de Cumplimiento',
          PROPIETARIO_RIESGO: 'Propietario de Riesgo',
          AUDITOR_INTERNO: 'Auditor Interno',
          RESPONSABLE_CALIDAD: 'Responsable de Calidad',
          PROPIETARIO_PROCESO: 'Propietario de Proceso',
          MIEMBRO_CONSEJO: 'Miembro del Consejo',
          SECRETARIO_CONSEJO: 'Secretario del Consejo',
          PERSONALIZADO: 'Personalizado',
        },
        modal: {
          tituloNuevo: 'Nuevo rol de gobernanza',
          tituloEditar: 'Editar rol de gobernanza',
          tipoRol: 'Tipo de rol',
          puestoAsignado: 'Puesto asignado',
          seleccionar: 'Seleccionar...',
          nombrePersonalizado: 'Nombre personalizado',
          placeholderNombre: 'Solo si tipo = PERSONALIZADO',
          ambito: 'Ámbito',
          placeholderAmbito: 'Rango de procesos...',
          cancelar: 'Cancelar',
          guardando: 'Guardando...',
          guardar: 'Guardar',
          errorGuardar: 'Error al guardar',
          camposObligatorios: 'Tipo de rol y puesto son obligatorios',
        },
        // 0469: extras listado plano
        mostrarInactivos: 'Mostrar inactivos',
        toastActivado: 'Rol activado',
        toastDesactivado: 'Rol desactivado',
        confirmDesactivar: '¿Desactivar este rol de gobernanza?',
        toggleActivoError: 'No se pudo cambiar el estado',
        verAuditoria: 'Ver auditoría',
        colConflicto: 'Conflicto',
        acciones: 'Acciones',
        editar: 'Editar',
        eliminar: 'Eliminar',
        sinConflictos: 'Sin conflictos',
        conflictoIndependencia: 'Conflicto de independencia',
        sinPuestoAsignado: 'Sin puesto asignado',
        ambito: 'Ámbito',
        de: 'de',
        roles: 'roles',
      },
      // 0469: Panel unificado rol de gobernanza — 3 tabs Datos | Ficha FG | Auditoría.
      rolGobernanzaPanel: {
        nuevoRol: 'Nuevo rol de gobernanza',
        tabDatos: 'Datos',
        tabFicha: 'Ficha FG',
        tabAuditoria: 'Auditoría',
        fichaDeshabilitada: 'Los roles de este tipo no disponen de ficha FG específica',
        auditoriaDeshabilitada: 'Disponible tras guardar el rol',
        tipoRol: 'Tipo de rol',
        puesto: 'Puesto asignado',
        ambito: 'Ámbito',
        ambitoHelp: 'Alcance de aplicación del rol',
        nombrePersonalizado: 'Nombre personalizado',
        nombrePersonalizadoSoloPersonalizado:
          'Solo disponible cuando el tipo de rol es PERSONALIZADO',
        nombrePersonalizadoPlaceholder: 'p. ej. Owner de riesgo IT',
        activo: 'Activo',
        seleccionar: 'Seleccionar...',
        personaEnPuesto: 'Persona en el puesto',
        rolSistemaNoEditable: 'Rol de sistema — tipoRol, puesto y activo no son editables',
        errorTipoObligatorio: 'Tipo de rol obligatorio',
        errorPuestoObligatorio: 'Puesto obligatorio',
        cancelar: 'Cancelar',
        guardar: 'Guardar',
        saving: 'Guardando...',
        fichaNoExiste: 'Este rol no tiene ficha FG asociada.',
        crearFicha: 'Crear ficha de rol de gobernanza',
        creandoFicha: 'Creando...',
        fichaCreada: 'Ficha creada',
        fichaGuardada: 'Ficha guardada',
        fichaMision: 'Misión del rol',
        fichaFunciones: 'Funciones y responsabilidades',
        fichaCompetencias: 'Competencias requeridas',
        fichaRelaciones: 'Relaciones clave',
        fichaIndicadores: 'Indicadores de desempeño',
        errorCargarFicha: 'Error al cargar la ficha',
        errorCargarAuditoria: 'Error al cargar la auditoría',
        auditoriaVacia: 'Este rol aún no tiene registros de auditoría.',
        auditoriaLimiteNota: 'Mostrando las últimas 50 entradas. Acceso completo desde Compliance.',
        auditoriaAccionCrear: 'Creado',
        auditoriaAccionActualizar: 'Actualizado',
        auditoriaAccionEliminar: 'Eliminado',
        auditoriaUsuarioDesconocido: 'Usuario desconocido',
        auditoriaDatosAnteriores: 'Datos anteriores',
        auditoriaDatosNuevos: 'Datos nuevos',
      },
      // 0470: nuevo catalogo de tipos de rol de gobernanza (por tenant).
      tiposRolGobernanza: {
        titulo: 'Roles de gobernanza',
        buscar: 'Buscar...',
        mostrarInactivos: 'Mostrar inactivos',
        nuevoCustom: 'Nuevo rol personalizado',
        nuevoCustomTitulo: 'Nuevo rol de gobernanza personalizado',
        nombre: 'Nombre',
        descripcion: 'Descripción',
        cancelar: 'Cancelar',
        crear: 'Crear',
        nombreRequerido: 'Nombre requerido',
        tipoCreado: 'Tipo de rol creado',
        tipoEliminado: 'Tipo eliminado',
        sistemaNoDesactivable: 'Los tipos de sistema no se pueden desactivar',
        confirmEnUso: 'Este tipo tiene asignaciones activas. Reasígnalas o desactívalas primero.',
        confirmEliminar: '¿Eliminar este tipo de rol?',
        badgeSistema: 'SISTEMA',
        ambitoGlobal: 'Global',
        ambitoPorProceso: 'Por proceso',
        colNombre: 'Nombre',
        colDescripcion: 'Descripción',
        colAmbito: 'Ámbito',
        colPuestos: 'Puestos',
        colActivo: 'Activo',
        colFicha: 'Ficha FG',
        colAcciones: 'Acciones',
        estadoActivo: 'Activo',
        estadoInactivo: 'Inactivo',
        fichaVer: 'Ver FG',
        fichaCrear: 'Crear FG',
        editar: 'Editar',
        eliminar: 'Eliminar',
        sinResultados: 'Sin resultados',
        // 0473 — homogeneizacion con RF (contador inferior + toggle en acciones)
        contadorRoles: 'roles',
        toggleActivar: 'Activar',
        toggleDesactivar: 'Desactivar',
      },
      // 0470: panel rediseñado para Tipo de Rol de Gobernanza (4 tabs).
      tipoRolGobernanzaPanel: {
        tabDatos: 'Datos',
        tabAsignaciones: 'Asignaciones',
        tabFicha: 'Ficha FG',
        tabAuditoria: 'Auditoría',
        asignacionesDeshabilitada: 'Guarda el tipo primero',
        fichaDeshabilitada: 'Guarda el tipo primero',
        auditoriaDeshabilitada: 'Guarda el tipo primero',
        nuevoTipo: 'Nuevo tipo de rol',
        badgeSistema: 'SISTEMA',
        codigo: 'Código',
        nombre: 'Nombre',
        descripcion: 'Descripción',
        ambito: 'Ámbito',
        ambitoGlobal: 'Global',
        ambitoPorProceso: 'Por proceso (se gestiona desde la ficha del proceso)',
        activo: 'Activo',
        avisoSistema:
          'Este tipo de rol es del sistema: el nombre no se puede cambiar y las asignaciones se gestionan desde la ficha del proceso.',
        sistemaSiempreActivo: '(Los tipos de sistema no se pueden desactivar)',
        guardar: 'Guardar',
        creacionDesdeCatalogo: 'Los tipos nuevos se crean desde el catálogo',
        porProcesoInfo: 'Los roles por proceso se gestionan desde la ficha de cada proceso.',
        seleccionarPuesto: 'Selecciona un puesto',
        asignar: 'Asignar puesto',
        confirmDesasignar: '¿Quitar esta asignación?',
        asignacionesActivas: 'Asignaciones activas',
        sinAsignaciones: 'Sin asignaciones activas',
        vacante: 'Vacante',
        quitar: 'Quitar',
        errorCargar: 'No se pudo cargar el detalle',
      },
      // 0453: estados de ocupacion (1 puesto = 1 asignacion activa max)
      estadoVacante: 'Vacante',
      estadoOcupado: 'Ocupado',
      paginationPrev: 'Anterior',
      paginationNext: 'Siguiente',
      paginationPage: 'Página',
      // Panel unificado de puesto (0453): 5 tabs Datos | Asignaciones | Organigrama | Ficha | RolesGobernanza
      puestoPanel: {
        nuevoPuesto: 'Nuevo puesto',
        tabDatos: 'Datos',
        tabAsignaciones: 'Asignaciones',
        tabOrganigrama: 'Organigrama',
        tabFicha: 'Ficha',
        tabRolesGobernanza: 'Roles de gobernanza',
        // 0470 M9: reciprocidad con tab roles de gobernanza
        rolesGobernanzaInfo:
          'Roles de gobernanza asignados a este puesto. Los roles por proceso (Representante, Dirección responsable) se gestionan desde la ficha del proceso.',
        seleccionarRol: 'Selecciona un tipo de rol',
        asignarRol: 'Asignar rol',
        rolesActivos: 'Roles activos',
        sinRolesGobernanza: 'Sin roles de gobernanza asignados',
        badgeSistema: 'SISTEMA',
        gestionadoPorProceso: 'Gestionado desde el proceso',
        quitar: 'Quitar',
        confirmDesasignarRol: '¿Quitar este rol del puesto?',
        sistema: 'Sistema',
        labelTitulo: 'Título',
        labelCodigo: 'Código',
        labelNivel: 'Nivel',
        labelRolFuncional: 'Rol funcional',
        labelOrganizacion: 'Organización',
        labelDepartamento: 'Departamento',
        codigoPreview: '(preview)',
        codigoAutogenerado: '(autogenerado)',
        codigoPendiente: '(se generará al guardar)',
        requiredTitulo: 'El título es obligatorio',
        requiredNivel: 'El nivel es obligatorio',
        requiredOrg: 'La organización es obligatoria',
        save: 'Guardar',
        saving: 'Guardando...',
        cancel: 'Cancelar',
        createPuesto: 'Crear puesto',
        asignacionesHeader: 'Asignaciones del puesto',
        asignarPersona: 'Asignar persona',
        tooltipOcupado: 'Finaliza la asignación previa antes',
        sinAsignaciones: 'Sin asignaciones',
        colPersona: 'Persona',
        colCodigoPersona: 'Código',
        colFechaInicio: 'Fecha inicio',
        colEstado: 'Estado',
        colAccion: 'Acción',
        estadoActivo: 'Activo',
        estadoFinalizado: 'Finalizado',
        finalizar: 'Finalizar',
        asignacionFinalizada: 'Asignación finalizada',
        errorFinalizar: 'Error al finalizar la asignación',
        asignacionCreada: 'Persona asignada correctamente',
        asignarPersonaA: 'Asignar persona a',
        buscarPersona: 'Buscar persona',
        placeholderBuscar: 'Nombre o código...',
        fechaInicio: 'Fecha inicio',
        fte: 'FTE (0-1)',
        esPrincipal: 'Es principal',
        asignar: 'Asignar',
        asignando: 'Asignando...',
        seleccionaPersona: 'Selecciona una persona',
        reportaA: 'Reporta a',
        sinPadre: 'Sin superior',
        supervisa: 'Supervisa',
        sinHijos: 'No supervisa puestos',
        editarOrganigrama: 'Editar en organigrama',
        fichaPuesto: 'Ficha del puesto',
        fichaNoExiste: 'Este puesto no tiene ficha de puesto.',
        crearFicha: 'Crear ficha de puesto',
        creandoFicha: 'Creando...',
        guardarFicha: 'Guardar ficha',
        fichaCreada: 'Ficha creada correctamente',
        fichaGuardada: 'Ficha guardada',
        errorCargarFicha: 'Error al cargar la ficha',
        fichaMision: 'Misión del puesto',
        fichaFunciones: 'Funciones y responsabilidades',
        fichaCompetenciasTecnicas: 'Competencias técnicas',
        fichaCompetenciasTransversales: 'Competencias transversales',
        fichaFormacion: 'Formación académica requerida',
        fichaExperiencia: 'Experiencia profesional requerida',
        fichaCertificaciones: 'Certificaciones obligatorias',
        fichaCondiciones: 'Condiciones del puesto',
        // 0454 M2 · UX: tooltip, dirty state warning, footers por tab
        asignarPersonaTooltipOcupado:
          'Finaliza la asignación activa antes de asignar otra persona.',
        dirtyWarningTitle: 'Cambios sin guardar',
        dirtyWarningMessage: 'Tienes cambios sin guardar en {tabs}. ¿Descartarlos?',
        dirtyWarningDiscard: 'Descartar y cerrar',
        dirtyWarningCancel: 'Volver al panel',
        guardarOrganigrama: 'Guardar organigrama',
        cancelarOrganigrama: 'Cancelar',
        guardarFichaTab: 'Guardar ficha',
        cancelarFicha: 'Cancelar',
        // 0454 M3 · Organigrama editable
        supervisor: 'Supervisor',
        sinPadreSeleccionado: 'Sin superior asignado',
        placeholderBuscarPadre: 'Buscar puesto padre...',
        // 0454 M4 · Toolbar Tiptap (titles SVG inline)
        toolbarHeading1: 'Título 1',
        toolbarHeading2: 'Título 2',
        toolbarHeading3: 'Título 3',
        toolbarBold: 'Negrita',
        toolbarItalic: 'Cursiva',
        toolbarUnderline: 'Subrayado',
        toolbarBulletList: 'Lista',
        toolbarOrderedList: 'Lista numerada',
        toolbarBlockquote: 'Cita',
        toolbarAlignLeft: 'Alinear izquierda',
        toolbarAlignCenter: 'Alinear centro',
        toolbarAlignRight: 'Alinear derecha',
        toolbarColor: 'Color',
        toolbarColorBlack: 'Negro',
        toolbarColorBlue: 'Azul',
        toolbarColorRed: 'Rojo',
        toolbarColorGreen: 'Verde',
        toolbarClearFormat: 'Limpiar formato',
        toolbarUndo: 'Deshacer',
        toolbarRedo: 'Rehacer',
      },
    },
    madurez: {
      codigo: 'Código',
      cuestionarioLecturaSolo: 'Diagnóstico aprobado · cuestionario congelado (solo lectura)',
      fuenteAnalisis: 'Analizar',
      fuente_CUESTIONARIO: 'Cuestionario',
      fuente_REAL: 'Real',
      fuente_AMBAS: 'Ambas',
      niveles: 'Niveles — pasa el ratón por una celda para el detalle',
      resumenEjecutivo: 'Resumen ejecutivo',
      dafo: 'Matriz DAFO',
      lecturaConsultor: 'Lectura del consultor',
      borradorIa: 'Borrador IA',
      requiereRevision: 'Requiere revisión',
      conclusionBloqueada: 'Diagnóstico aprobado · solo lectura',
      pick_QUICK_WIN: 'Quick win',
      pick_RETO: 'Reto',
      pick_POSIBLE: 'Posible',
      pick_DESCARTAR: 'Descartar',
      escenarios: 'Escenarios what-if',
      nuevoEscenario: 'Crear escenario',
      sinEscenarios: 'Aún no hay escenarios. Crea uno para simular un cambio estructural.',
      viable: 'Viable',
      noViable: 'No viable',
      impulsoras: 'Impulsoras',
      restrictivas: 'Restrictivas',
      evaluarEscenario: 'Evaluar',
      generarDesde: 'Generar a partir de este',
      lectura: 'Lectura',
      vistaReal: 'Real (organigrama)',
      vistaCuestionario: 'Cuestionario',
      nivelGlobalReal: 'Nivel global · Real',
      nivelGlobalCuest: 'Nivel global · Cuestionario',
      coberturaCuest: 'Cuestionario',
      opcional: '(opcional)',
      errMotorNoDisponible:
        'El motor de IA no está disponible o sin cuota. Reintenta o revisa los proveedores.',
      errRespuestaInvalida: 'La IA devolvió una respuesta no válida. Reintenta.',
      errGenerico: 'Se produjo un error. Reintenta.',
      conclusionConsultor: 'Conclusión del ingeniero de gobernanza',
      conclusionPlaceholder: 'Tu lectura experta del contexto, más allá del dato objetivo…',
      hojaRuta: 'Hoja de ruta',
      responsable: 'Responsable',
      horizonte: 'Horizonte',
      discrepanciaRealCuest: 'Discrepancias realidad ↔ cuestionario',
      colDimension: 'Dimensión',
      colReal: 'Real',
      colPercepcion: 'Percepción',
      colLectura: 'Lectura',
      lecturaSinDato: 'Sin dato de cuestionario',
      lecturaCoincide: 'Coincide',
      lecturaInfravalora: 'Se infravalora: la realidad supera la percepción',
      lecturaSobreestima: 'Se sobreestima: se percibe más madura de lo real',
      guardarConclusion: 'Guardar conclusión',
      guardado: 'Guardado',
      generando: 'Generando análisis…',
      regenerar: 'Regenerar análisis IA',
      generarAnalisis: 'Generar análisis IA',
      via: 'V·IA',
      cargando: 'Cargando…',
      sinAnalisis: 'Aún no hay análisis IA. Genera uno para obtener diagnóstico y recomendaciones.',
      sentinel: 'Sentinel',
      sentinelError: 'alertas críticas — el análisis no puede validarse hasta resolverlas.',
      sentinelWarn: 'avisos a revisar.',
      diagnostico: 'Diagnóstico',
      recomendaciones: 'Recomendaciones',
      noAnclada: 'propuesta IA',
      anclada: 'anclada al catálogo',
      fortalezas: 'Fortalezas',
      riesgos: 'Riesgos',
      validar: 'Validar análisis',
      bloqueadoSentinel: 'Bloqueado por Sentinel',
      generandoInforme: 'Generando informe…',
      descargarInforme: 'Descargar informe Word',
      descargarPy: 'Descargar exportador .py',
      generandoPy: 'Generando .py…',
      generarMegaprompt: 'Generar megaprompt claude.ai',
      generandoMegaprompt: 'Generando megaprompt…',
      verInformeHtml: 'Generar informe HTML',
      generandoHtml: 'Generando HTML…',
    },
  },

  // People module
  people: {
    title: 'Personas',
    directory: 'Directorio de Personas',
    newPerson: '+ Nueva Persona',
    total: 'Total',
    employees: 'Empleados',
    collaborators: 'Colaboradores',
    externals: 'Externos',
    active: 'Activos',
    inactive: 'Bajas',
    noPosition: 'Sin puesto',
    filteredStats: 'Estadisticas filtradas',
    searchPlaceholder: 'Buscar por nombre, apellidos o email...',
    allTypes: 'Todos los tipos',
    employee: 'Empleado',
    collaborator: 'Colaborador',
    external: 'Externo',
    all: 'Todos',
    activeFilter: 'Activo',
    inactiveFilter: 'Baja',
    allDepts: 'Todos los departamentos',
    fullName: 'Nombre completo',
    position: 'Puesto',
    type: 'Tipo',
    loadingDirectory: 'Cargando directorio...',
    noPersonsFound: 'No se encontraron personas con los filtros aplicados.',
    previous: 'Anterior',
    pageOf: (page: number, total: number) => `Pagina ${page} de ${total}`,
    next: 'Siguiente',
    // Create person modal
    newPersonTitle: 'Nueva Persona',
    code: 'Codigo',
    personType: 'Tipo Persona',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    email: 'Email',
    phone: 'Telefono',
    hireDate: 'Fecha de Alta',
    contractType: 'Tipo Contrato',
    directionCode: 'Codigo Direccion',
    requiredFields: 'Codigo, nombre, apellidos y email son obligatorios',
    errorCreatePerson: 'Error al crear persona',
    creatingPerson: 'Creando...',
    createPerson: 'Crear Persona',
    assetsPlaceholder:
      'Los activos asignados a esta persona se gestionan desde el modulo V·IA Inventario.',
    goToInventory: 'Ir a Inventario',
    form: {
      code: 'Codigo *',
      personType: 'Tipo Persona *',
      firstName: 'Nombre *',
      lastName: 'Apellidos *',
      email: 'Email *',
      phone: 'Telefono',
      hireDate: 'Fecha de Alta',
      contractType: 'Tipo Contrato',
      directionCode: 'Codigo Direccion',
      nif: 'NIF',
      displayName: 'Nombre a mostrar',
      secondaryEmail: 'Email secundario',
      mobilePhone: 'Telefono movil',
      status: 'Estado',
      jobCategory: 'Categoria laboral',
      terminationDate: 'Fecha baja',
      birthDate: 'Fecha nacimiento',
      supervisor: 'Supervisor',
      country: 'Pais',
      gender: 'Genero',
      readOnly: '(solo lectura)',
      codigoAutogenerado: '(autogenerado)',
      paisDerivadoTooltip: 'Derivado del centro principal',
      department: 'Departamento',
      tipoCosto: 'Tipo de coste',
      centroCostes: 'Centro de costes (Proyecto)',
      workCenter: 'Centro de trabajo',
      center: 'Centro de trabajo',
      cambioEstadoTitulo: (de: string, a: string) => `Cambio de estado: ${de} → ${a}`,
      cambioEstadoMotivo: 'Motivo',
      cambioEstadoFecha: 'Fecha cambio',
      cambioEstadoObs: 'Observaciones',
      cambioEstadoObsPlaceholder: 'Opcional',
      cambioEstadoConfirmar: 'Confirmar cambio',
      cambioEstadoMotivoBaja: 'El motivo es obligatorio para este cambio de estado',
    },
    placeholders: {
      code: 'EMP-XXX',
      contractType: 'Indefinido',
    },
    validation: {
      required: 'Campo obligatorio',
      emailFormat: 'Formato de email invalido',
      codeRequired: 'El codigo es obligatorio',
      nameRequired: 'El nombre es obligatorio',
      lastNameRequired: 'Los apellidos son obligatorios',
      emailRequired: 'El email es obligatorio',
    },
    pageSize: 'por pagina',
    showing: (from: number, to: number, total: number) => `${from}-${to} de ${total}`,
    selectAll: 'Seleccionar todo',
    selected: (n: number) => `${n} seleccionados`,
    bulkTerminate: (n: number) => `Dar de baja (${n})`,
    bulkExportCsv: (n: number) => `Exportar CSV (${n})`,
    confirmBulkTerminate: (n: number) =>
      `Dar de baja a ${n} personas? Esta accion cerrara sus asignaciones activas.`,
    bulkTerminateSuccess: (n: number) => `${n} personas dadas de baja correctamente`,
    bulkTerminateError: 'Error al dar de baja personas',
    // Detail page
    loadingPerson: 'Cargando persona...',
    personNotFound: 'Persona no encontrada',
    terminate: 'Dar de Baja',
    confirmTerminate: 'Dar de baja a esta persona? Se cerraran todas sus asignaciones activas.',
    confirmFinalizarAsignacion:
      'Finalizar esta asignacion? Los datos se conservaran en el historial.',
    confirmDesasignarProyecto: 'Desasignar a esta persona del proyecto?',
    confirmDesasignarCentro: 'Desasignar a esta persona de este centro?',
    // Detail tabs
    personalData: 'Datos Personales',
    positionAndChart: 'Puesto y Organigrama',
    projects: 'Proyectos',
    centers: 'Centros',
    assets: 'Activos',
    governanceTab: 'Gobernanza',
    processesAndDocs: 'Procesos y Documentos',
    processesRepresented: 'Procesos representados',
    noProcesses: 'Sin procesos asignados',
    documentsCreated: 'Documentos creados',
    documentsApproved: 'Documentos aprobados',
    noDocuments: 'Sin documentos',
    noGovernanceRoles: 'Sin roles de gobernanza asignados',
    rolesByPosition: 'Roles por puesto',
    directRoles: 'Roles directos',
    // Data tab
    savedOk: 'Guardado correctamente',
    saveChanges: 'Guardar Cambios',
    // Position tab
    currentPosition: 'Puesto Actual',
    noPositionAssigned: 'Sin puesto asignado',
    orgChartPosition: 'Posicion en Organigrama',
    positionHistory: 'Historial de Puestos',
    noHistory: 'Sin historial',
    puesto: 'Puesto',
    department: 'Departamento',
    from: 'Desde',
    to: 'Hasta',
    status: 'Estado',
    activeStatus: 'Activo',
    finishedStatus: 'Finalizado',
    finalize: 'Finalizar',
    confirmFinalize: 'Finalizar esta asignacion?',
    // Projects tab
    assignedProjects: 'Proyectos Asignados',
    noProjects: 'Sin proyectos asignados',
    project: 'Proyecto',
    role: 'Rol',
    dedication: 'Dedicacion',
    unassign: 'Desasignar',
    confirmUnassignProject: 'Desasignar de este proyecto?',
    // Centers tab
    workCenters: 'Centros de Trabajo',
    noCenters: 'Sin centros asignados',
    center: 'Centro',
    city: 'Ciudad',
    primary: 'Principal',
    yes: 'Si',
    no: 'No',
    confirmUnassignCenter: 'Desasignar de este centro?',
    // Assets tab
    assignedAssets: 'Activos Asignados',
    noAssets: 'Sin activos asignados (los activos se gestionan desde V·IA Inventario)',
    asset: 'Activo',
    // Governance tab
    governanceRoles: 'Roles de Gobernanza',
    noGovernanceRolesLegacy: 'Sin roles de gobernanza asignados (se asignan a traves del puesto)',
    scope: 'Ambito',
    processOwner: 'Propietario de Proceso',
    dpo: 'Delegado de Proteccion de Datos',
    complianceOfficer: 'Oficial de Cumplimiento',
    internalAuditor: 'Auditor Interno',
    boardMember: 'Miembro del Consejo',
    // Persona drawer (read-only from directory)
    personaDrawer: {
      title: 'Detalle de Persona',
      contact: 'Contacto',
      positionInfo: 'Puesto y Departamento',
      organization: 'Organizacion',
      miniOrgChart: 'Mini-organigrama',
      supervisor: 'Supervisor directo',
      subordinates: 'Subordinados directos',
      main: 'Principal',
    },
    historialEstado: {
      titulo: 'Historial de estado',
      sinCambios: 'Sin cambios registrados.',
      colFecha: 'Fecha',
      colDe: 'De',
      colA: 'A',
      colMotivo: 'Motivo',
      colObservaciones: 'Observaciones',
      colPor: 'Por',
    },
  },

  // Home page
  home: {
    searchPlaceholder: 'Buscar documentos, procesos, personas...',
    documents: 'Documentos',
    processes: 'Procesos',
    pending: 'Pendientes',
    current: 'Vigentes',
    engineerings: 'Ingenierías de Gobernanza',
    recentActivity: 'Actividad Reciente',
    noRecentActivity: 'Sin actividad reciente',
    news: 'Noticias',
    pendingDocs: 'Pendientes',
    created: 'Creado',
    updated: 'Actualizado',
    deleted: 'Eliminado',
    sent: 'Enviado',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    published: 'Publicado',
  },

  // Quick search
  search: {
    searching: 'Buscando...',
    noResultsFound: 'No se encontraron resultados',
    recentDocs: 'Documentos recientes',
    typeToSearch: 'Escribe para buscar documentos por nombre o codigo',
    searchTooltip: 'Buscar (Ctrl+K)',
  },

  // Breadcrumb
  breadcrumb: {
    home: 'Inicio',
    detail: 'Detalle',
    admin: 'Administracion',
    aiAssistant: 'Asistente IA',
    orgChart: 'Organigrama',
    organizations: 'Organizaciones',
    governance: 'Gobernanza',
    people: 'Personas',
    processMap: 'Mapa de Procesos',
    characterization: 'Caracterización',
    smartSearch: 'Busqueda Inteligente',
    docAudit: 'Auditoria Documental',
    dashboards: 'Cuadros de Mando',
    regulations: 'Normativa',
    internalAudits: 'Auditorias Internas',
    nonConformities: 'No Conformidades',
    projects: 'Proyectos',
    purchases: 'Compras',
    assets: 'Activos',
    requests: 'Peticiones',
    news: 'Noticias',
    surveys: 'Encuestas',
    events: 'Eventos',
    settings: 'Configuracion',
    import: 'Importar',
    assistant: 'Asistente',
    document: 'Documento',
    process: 'Proceso',
    processSheet: 'Ficha de Proceso',
  },

  // Settings page
  settings: {
    loadingConfig: 'Cargando configuracion...',
    brandTab: 'Identidad y Marca',
    generalTab: 'Configuración General',
    usersTab: 'Usuarios',
    statsTab: 'Estadísticas',
    configSaved: 'Configuracion guardada correctamente',
    logoUpdated: 'Logo actualizado',
    errorUpload: 'Error al subir archivo',
    // Brand
    brand: 'Marca',
    brandName: 'Nombre de Marca',
    font: 'Fuente tipografica',
    colors: 'Colores',
    primary: 'Primario',
    secondary: 'Secundario',
    accent: 'Acento',
    preview: 'Vista previa',
    logos: 'Logos',
    mainLogo: 'Logo principal',
    headerLogo: 'Logo header',
    favicon: 'Favicon',
    saving: 'Guardando...',
    saveChanges: 'Guardar cambios',
    // General config
    generalConfig: 'Configuracion General',
    language: 'Idioma',
    spanish: 'Espanol',
    timezone: 'Zona Horaria',
    customDomain: 'Dominio personalizado',
    plan: 'Plan',
    activeModules: 'Modulos activos',
    // Users
    users: 'Usuarios',
    newUser: '+ Nuevo usuario',
    name: 'Nombre',
    emailCol: 'Email',
    roleCol: 'Rol',
    statusCol: 'Estado',
    actionsCol: 'Acciones',
    activeUser: 'Activo',
    inactiveUser: 'Inactivo',
    deactivate: 'Desactivar',
    confirmDeactivate: 'Se desactivara este usuario. Continuar?',
    userDeactivated: 'Usuario desactivado',
    newUserTitle: 'Nuevo usuario',
    fullName: 'Nombre completo',
    emailAndNameRequired: 'Email y nombre son obligatorios',
    userCreated: 'Usuario creado correctamente',
    creatingUser: 'Creando...',
    createUser: 'Crear usuario',
    // Stats
    tenantStats: 'Estadisticas del Tenant',
    totalUsers: 'Total Usuarios',
    activeUsers: 'Usuarios Activos',
    totalDocs: 'Total Documentos',
    publishedDocs: 'Documentos Publicados',
    totalProcesses: 'Total Procesos',
    loadingStats: 'Cargando estadisticas...',
  },

  // Audit page (compliance)
  audit: {
    title: 'Auditoría Documental',
    allEntities: 'Todas las entidades',
    allActions: 'Todas las acciones',
    fromDate: 'Desde',
    toDate: 'Hasta',
    clearFilters: 'Limpiar filtros',
    refresh: 'Actualizar',
    date: 'Fecha',
    user: 'Usuario',
    action: 'Acción',
    entity: 'Entidad',
    detail: 'Detalle',
    loadingRecords: 'Cargando registros...',
    noRecordsFound: 'No se encontraron registros de auditoría',
    pageOf: (page: number, total: number, records: number) =>
      `Página ${page} de ${total} · ${records} registros`,
    previous: 'Anterior',
    next: 'Siguiente',
    errorLoading: 'Error al cargar los registros de auditoría',
    actions: {
      createDoc: 'Crear Documento',
      editDoc: 'Editar Documento',
      sendReview: 'Enviar a Revisión',
      approveVersion: 'Aprobar Versión',
      rejectVersion: 'Rechazar Versión',
      publishDoc: 'Publicar Documento',
      deactivate: 'Dar de Baja',
      createRef: 'Crear Referencia',
      deleteRef: 'Eliminar Referencia',
      startChat: 'Iniciar Conversación',
      login: 'Login',
      logout: 'Logout',
    },
  },

  // Compliance module
  compliance: {
    tabs: {
      normative: 'Normativa',
      internalAudit: 'Auditorías Internas',
      nonConformities: 'No Conformidades',
    },
    landing: {
      title: 'Cumplimiento Normativo',
      description:
        'Normativa, auditorías, no conformidades y acciones correctivas. Asegura el cumplimiento de los estándares corporativos.',
      normativeDesc: 'Gestión del marco normativo corporativo y cumplimiento regulatorio',
      auditDesc: 'Planificación y seguimiento de auditorías internas del sistema',
      nonConformitiesDesc: 'Registro y tratamiento de no conformidades y acciones correctivas',
    },
  },

  // Process module
  process: {
    madurezEmpresa: {
      tab: 'Madurez empresa',
      errorEvals: 'No se pudieron cargar las evaluaciones',
      errorHeatmap: 'No se pudo cargar el heatmap',
      errorCrear: 'No se pudo crear la evaluación (¿permiso de edición?)',
      errorSembrar: 'No se pudieron sembrar las capacidades',
      errorConclusion: 'No se pudo guardar la conclusión',
      errorAprobar: 'No se pudo aprobar (¿rol directivo?)',
      titulo: 'Madurez de la empresa · PEMM (capacidad de transformación)',
      nueva: '+ Nueva evaluación',
      global: 'Nivel de la empresa',
      vacio:
        'Aún no hay evaluación de capacidad de transformación. Crea la primera con «+ Nueva evaluación».',
      sinSiembra:
        'La evaluación no tiene capacidades. Siembra las 13 en E-1 para empezar el audit.',
      sembrar: 'Sembrar 13 capacidades',
      heatmap: 'Matriz de capacidades 13 × 4',
      aprobar: 'Aprobar evaluación',
      aprobada: '✓ Aprobada (solo lectura)',
      verDetalle: 'Resaltar en el cuestionario',
      eslabon: 'Eslabón débil: marca el nivel de la empresa',
      conNota: 'Tiene nota',
      radar: 'Radar por categorías (eslabón débil)',
      evolucion: 'Evolución de la empresa',
      sinEvolucion: 'Con una sola evaluación aún no hay evolución que mostrar.',
      conclusion: 'Conclusión del ingeniero de gobernanza',
      conclusionPh:
        'Síntesis: ¿la empresa puede sostener la mejora de sus procesos? Eslabón(es) débil(es), qué desbloquea el siguiente nivel…',
      guardando: 'Guardando…',
      guardar: 'Guardar',
      guardado: '✓ Guardado',
      cuestionarioTitulo: 'Cuestionario PEMM-Empresa',
      errorGuardar: 'No se pudo guardar (¿permiso de edición?)',
      anadirNota: 'Añadir nota',
      lecturaSolo: 'Evaluación aprobada · cuestionario congelado (solo lectura)',
      cuestionarioAyuda:
        'Responde cada afirmación de 1 (Nada) a 4 (Plenamente). La media de una capacidad marca su nivel E; la empresa vale su eslabón más débil. El resultado se refleja en el heatmap y el radar al instante.',
      expandirBloques: 'Expandir bloques',
      contraerBloques: 'Contraer bloques',
      expandirNotas: 'Expandir notas',
      contraerNotas: 'Contraer notas',
      refNiveles: 'Referencia de niveles (Hammer)',
      iaErrorCargar: 'No se pudo cargar el análisis',
      iaErrorGenerar: 'No se pudo generar el análisis (¿permiso de edición o cuota?)',
      iaErrorValidar: 'No se pudo validar (¿rol directivo o alertas de Sentinel?)',
      iaErrorExport: 'No se pudo generar el informe (¿permiso de edición?)',
      iaTitulo: 'Análisis V·IA Governance',
      iaGenerando: 'Generando…',
      iaRegenerar: 'Regenerar análisis IA',
      iaGenerar: 'Generar análisis V·IA',
      iaValidado: '✓ Validado',
      iaGenerado: 'Generado',
      expWordTip: 'Informe Word corporativo (PO.34.MO.02)',
      expWord: 'Descargar informe Word',
      expPyTip: 'Exportador .py para reproducir el Word en claude.ai (PO.34.HE.02)',
      expPy: 'Descargar exportador .py',
      expMegaTip: 'Megaprompt .md para generar el informe premium en claude.ai',
      expMega: 'Generar megaprompt claude.ai',
      expHtmlTip: 'Informe HTML autónomo (abre en pestaña nueva)',
      expHtml: 'Generar informe HTML',
      iaVacio:
        'Aún no hay análisis. Genera uno: la V·IA leerá las 13 capacidades y diagnosticará el eslabón débil, qué desbloquea el siguiente nivel y un DAFO.',
      iaSentinel: '⚠ Sentinel marcó alertas críticas: revisa antes de validar.',
      iaResumen: 'Resumen ejecutivo',
      iaLecturaConsultor: 'Lectura del consultor',
      iaDafo: 'Matriz DAFO',
      iaDiagnostico: 'Diagnóstico',
      iaRecomendaciones: 'Recomendaciones',
      iaFortalezas: 'Fortalezas',
      iaRiesgos: 'Riesgos',
      iaValidando: 'Validando…',
      iaValidar: 'Validar análisis',
      iaBorrador: 'Borrador IA',
      tcoError: 'No se pudo guardar el estudio (¿permiso de edición?)',
      tcoTitulo: 'Estudio de inversión · TCO / ROI',
      tcoTotal: 'TCO total',
      roiHorizonte: 'ROI horizonte',
      roiPermanente: 'ROI permanente',
      payback: 'Payback',
      noRecuperado: 'No recuperado',
      flujoNeto: 'Flujo neto',
      flujoAcum: 'Flujo acumulado',
      horizonte: 'Horizonte (años)',
      costesDirectos: 'Costes directos (€)',
      costesIndirectos: 'Costes indirectos (€)',
      curvaAdopcion: 'Curva de adopción (0-1)',
      beneficios: 'Beneficios anuales (régimen permanente)',
      conceptoPh: 'Concepto (p.ej. reducción de reprocesos)',
      addBeneficio: '+ Añadir beneficio',
      tcoGuardar: 'Guardar estudio',
      tcoNota:
        'ROI horizonte = (Σ beneficios − TCO) / TCO × 100. Beneficio del año = pleno × curva de adopción.',
    },
    madurezPemm: {
      tab: 'Madurez proceso',
      titulo: 'Madurez del proceso · PEMM (Hammer)',
      proceso: 'Proceso',
      elegirProceso: '— Elige un proceso —',
      evaluacion: 'Evaluación',
      nueva: '+ Nueva evaluación',
      global: 'Nivel del proceso',
      vacioProceso: 'Elige un proceso para evaluar su madurez PEMM (13 habilitadores de Hammer).',
      vacioEval:
        'Este proceso aún no tiene evaluaciones PEMM. Crea la primera con «+ Nueva evaluación».',
      sinSiembra:
        'La evaluación no tiene habilitadores. Siembra los 13 en P-1 para empezar el audit.',
      sembrar: 'Sembrar 13 habilitadores (pre-fill desde el mapa)',
      heatmap: 'Matriz de habilitadores 13 × 4',
      aprobar: 'Aprobar evaluación',
      aprobada: '✓ Aprobada (solo lectura)',
      eslabon: 'Eslabón débil: marca el nivel del proceso',
      errorProcesos: 'No se pudieron cargar los procesos',
      errorEvals: 'No se pudieron cargar las evaluaciones',
      errorHeatmap: 'No se pudo cargar el heatmap',
      errorCrear: 'No se pudo crear la evaluación (¿permiso de edición?)',
      errorSembrar: 'No se pudieron sembrar los habilitadores',
      errorGuardar: 'No se pudo guardar el nivel (¿permiso de edición?)',
      errorAprobar: 'No se pudo aprobar (¿rol directivo?)',
      verDetalle: 'Ver definición y notas',
      conNota: 'Tiene nota',
      cuestionarioTitulo: 'Cuestionario PEMM',
      cuestionarioAyuda:
        'Responde cada afirmación de 1 (Nada) a 4 (Plenamente). La media de un habilitador marca su nivel P; el proceso vale su eslabón más débil. El resultado se refleja en el heatmap y el radar al instante.',
      addNota: '+ Nota',
      notaVer: '📝 Nota',
      refNiveles: 'Referencia de niveles (Hammer)',
      expandirBloques: 'Expandir bloques',
      contraerBloques: 'Contraer bloques',
      expandirNotas: 'Expandir notas',
      contraerNotas: 'Contraer notas',
      anadirNota: 'Añadir nota',
      lecturaSolo: 'Evaluación aprobada · cuestionario congelado (solo lectura)',
      radar: 'Radar por categorías (eslabón débil)',
      evolucion: 'Evolución del proceso',
      sinEvolucion: 'Con una sola evaluación aún no hay evolución que mostrar.',
      conclusion: 'Conclusión del ingeniero de gobernanza',
      conclusionPh:
        'Síntesis del diagnóstico: eslabón(es) débil(es), qué desbloquea el siguiente nivel, prioridades…',
      guardando: 'Guardando…',
      guardar: 'Guardar',
      guardado: '✓ Guardado',
      metodoTitulo: 'Cómo se evalúa · PEMM (Hammer 2007)',
      metodoTexto:
        'Es una auditoría experta: por cada habilitador, elige el nivel P que el proceso cumple de verdad. El nivel del proceso = su eslabón más débil (mínimo). Sube el habilitador más débil para subir el proceso.',
      detalle: 'Detalle del habilitador',
      detalleVacio:
        'Selecciona un habilitador en la matriz para ver su definición por nivel y añadir tus notas.',
      notaIngeniero: 'Notas del ingeniero (evidencia)',
      notaPh: 'Evidencia que sustenta el nivel asignado…',
      guardarNota: 'Guardar nota',
      errorNota: 'No se pudo guardar la nota',
      errorConclusion: 'No se pudo guardar la conclusión',
      iaTitulo: 'Análisis V·IA Governance',
      iaResumen: 'Resumen ejecutivo',
      iaBorrador: 'Borrador IA',
      iaLecturaConsultor: 'Lectura del consultor',
      zenicTitulo: 'Evidencia de auditoría (ZENIC)',
      zenicCualitativa: 'Respuesta cualitativa (entrevista)',
      zenicCuantitativa: 'Respuesta cuantitativa (datos, %)',
      zenicAnalisis: 'Análisis para el color (por qué este nivel)',
      zenicLeccion: 'Lección aprendida',
      guardarZenic: 'Guardar evidencia',
      roadmapTitulo: 'Hoja de Ruta',
      matrizPick: 'Priorización PICK (impacto × complejidad)',
      kotter: 'Kotter',
      brecha: 'Brecha',
      owner: 'Owner',
      crucesTitulo: 'Estrategias cruzadas (DAFO)',
      cruceFo: 'FO · Fortalezas + Oportunidades (ofensiva)',
      cruceFa: 'FA · Fortalezas + Amenazas (defensiva)',
      cruceDo: 'DO · Debilidades + Oportunidades (reorientación)',
      cruceDa: 'DA · Debilidades + Amenazas (supervivencia)',
      iaGenerar: 'Generar análisis V·IA',
      iaRegenerar: 'Regenerar',
      iaGenerando: 'Generando…',
      iaGenerado: 'Generado',
      iaValidado: '✓ Validado',
      iaVacio:
        'Aún no hay análisis. Genera uno: la V·IA leerá los 13 habilitadores y diagnosticará el eslabón débil, qué desbloquea el siguiente nivel y un DAFO.',
      iaDiagnostico: 'Diagnóstico',
      iaRecomendaciones: 'Recomendaciones (priorizadas)',
      iaFortalezas: 'Fortalezas',
      iaRiesgos: 'Riesgos',
      iaDafo: 'Matriz DAFO',
      iaDafoF: 'Fortalezas',
      iaDafoD: 'Debilidades',
      iaDafoO: 'Oportunidades',
      iaDafoA: 'Amenazas',
      iaValidar: 'Validar análisis',
      iaValidando: 'Validando…',
      iaValidadoNota: '✓ Análisis validado (apto para informe)',
      iaSentinel: '⚠ Sentinel marcó alertas críticas: revisa antes de validar.',
      iaErrorCargar: 'No se pudo cargar el análisis',
      iaErrorGenerar: 'No se pudo generar el análisis (¿permiso de edición o cuota?)',
      iaErrorValidar: 'No se pudo validar (¿rol directivo o alertas de Sentinel?)',
      expMega: 'Generar megaprompt claude.ai',
      expMegaTip: 'Megaprompt .md para generar el informe premium en claude.ai',
      expHtml: 'Generar informe HTML',
      expHtmlTip: 'Informe HTML autónomo (abre en pestaña nueva)',
      iaErrorExport: 'No se pudo generar el informe (¿permiso de edición?)',
      expWord: 'Descargar informe Word',
      expWordTip: 'Informe Word corporativo (PO.34.MO.02)',
      expPy: 'Descargar exportador .py',
      expPyTip: 'Exportador .py para reproducir el Word en claude.ai (PO.34.HE.02)',
      tcoTitulo: 'Estudio de inversión · TCO / ROI',
      tcoTotal: 'TCO total',
      roiHorizonte: 'ROI horizonte',
      roiPermanente: 'ROI permanente',
      payback: 'Payback',
      noRecuperado: 'No recuperado',
      flujoNeto: 'Flujo neto',
      flujoAcum: 'Flujo acumulado',
      horizonte: 'Horizonte (años)',
      costesDirectos: 'Costes directos (€)',
      costesIndirectos: 'Costes indirectos (€)',
      curvaAdopcion: 'Curva de adopción (0-1)',
      beneficios: 'Beneficios anuales (régimen permanente)',
      conceptoPh: 'Concepto (p.ej. reducción de reprocesos)',
      addBeneficio: '+ Añadir beneficio',
      tcoGuardar: 'Guardar estudio',
      tcoError: 'No se pudo guardar el estudio (¿permiso de edición?)',
      tcoNota:
        'ROI horizonte = (Σ beneficios − TCO) / TCO × 100. Beneficio del año = pleno × curva de adopción.',
    },
    madurez: {
      title: 'Madurez de procesos · BPMM',
      loading: 'Cargando madurez de procesos…',
      nuevaEvaluacion: 'Nueva evaluación',
      aprobar: 'Aprobar',
      cuestionario: 'Cuestionario',
      ocultarCuestionario: 'Ocultar cuestionario',
      cuestionarioTitle: 'Cuestionario BPMM',
      cuestionarioLoading: 'Cargando cuestionario BPMM…',
      nivelGlobalReal: 'Nivel global · Real (mapa)',
      nivelGlobalCuest: 'Nivel global · Cuestionario',
      coberturaModelo: 'Cobertura del modelo',
      coberturaCuest: 'Cuestionario:',
      estado: 'Estado',
      codigo: 'Código:',
      emptyTitle: 'Sin evaluaciones de madurez de procesos',
      emptyDesc:
        'Crea una evaluación: el motor leerá el mapa de procesos y sembrará los 7 pilares BPMM.',
      lectura: 'Lectura:',
      vistaReal: 'Real (mapa de procesos)',
      vistaCuestionario: 'Cuestionario',
      heatmapTitle: 'Heatmap 7 pilares × 5 niveles',
      radarTitle: 'Radar 7 pilares',
      cuestIntro:
        'Responde según tu percepción (1 = Nunca, 5 = Siempre). El resultado se contrasta con la lectura real del mapa de procesos.',
      liderazgo: 'Liderazgo',
      anadirNota: 'Añadir nota',
      guardando: 'Guardando…',
      guardarRespuestas: 'Guardar respuestas',
      respuestasGuardadas: 'Respuestas guardadas',
      lecturaSolo: 'Evaluación aprobada · cuestionario congelado (solo lectura)',
      tab: 'Madurez',
      analisisIA: 'Análisis V·IA Governance',
      ocultarAnalisis: 'Ocultar análisis IA',
      discrepancias: 'Discrepancias del cuestionario',
      discrepanciasEmpty: 'Sin respuestas registradas todavía.',
      discrepante: 'Discrepancia (varianza ≥ umbral)',
      colPregunta: 'Pregunta',
      colRespondentes: 'Respond.',
      colVarianza: 'Varianza',
      timeline: 'Evolución del nivel global',
      timelineEmpty: 'Aún no hay histórico suficiente.',
      niveles: 'Niveles BPMM (Robledo) — pasa el ratón por una celda para el detalle',
      notasPilar: 'Notas de gobernanza',
      expandirBloques: 'Expandir bloques',
      contraerBloques: 'Contraer bloques',
      expandirNotas: 'Expandir notas',
      contraerNotas: 'Contraer notas',
      conclusionConsultor: 'Conclusión del ingeniero de gobernanza',
      opcional: '(opcional)',
      guardarConclusion: 'Guardar conclusión',
      conclusionBloqueada: 'Diagnóstico aprobado · solo lectura',
      conclusionPlaceholder: 'Tu lectura experta del contexto, más allá del dato objetivo…',
      guardado: 'Guardado',
      cuestionarioHint:
        'Selecciona una evaluación para responder y triangular el dato objetivo con la percepción.',
      analisis: {
        fuente: 'Fuente:',
        ambas: 'Ambas',
        real: 'Real',
        cuestionario: 'Cuestionario',
        generando: 'Generando análisis…',
        regenerar: 'Regenerar análisis IA',
        generar: 'Generar análisis IA',
        generarAnalisis: 'Generar análisis IA',
        validar: 'Validar análisis',
        cargando: 'Cargando…',
        vacio:
          'Aún no hay análisis. Genera uno: la IA diagnostica la madurez de procesos y propone acciones de mejora priorizadas (la IA propone, el consultor valida).',
        sinAnalisis:
          'Aún no hay análisis IA. Genera uno: la IA diagnostica la madurez de procesos y propone acciones de mejora priorizadas (la IA propone, el consultor valida).',
        basadoNotas: 'El análisis incorpora las notas de gobernanza del consultor.',
        recomendaciones: 'Recomendaciones',
        fortalezas: 'Fortalezas',
        riesgos: 'Riesgos',
        dafoFortalezas: 'FORTALEZAS',
        dafoDebilidades: 'DEBILIDADES',
        dafoOportunidades: 'OPORTUNIDADES',
        dafoAmenazas: 'AMENAZAS',
        analisisIA: 'Análisis V·IA Governance',
        descargarInforme: 'Descargar informe Word',
        descargarPy: 'Descargar exportador .py',
        generarMegaprompt: 'Generar megaprompt claude.ai',
        verInformeHtml: 'Generar informe HTML',
        resumenEjecutivo: 'Resumen ejecutivo',
        validado: 'Validado',
        borradorIa: 'Borrador IA',
        lecturaConsultor: 'Lectura del consultor',
        dafo: 'Matriz DAFO',
        diagnostico: 'Diagnóstico',
        anclada: 'anclada al catálogo',
        hojaRuta: 'Hoja de ruta',
        responsable: 'Responsable',
        horizonte: 'Horizonte',
        discrepancias: 'Discrepancias del cuestionario',
        discrepanciasEmpty: 'Sin respuestas registradas todavía.',
        colPregunta: 'Pregunta',
        colRespondentes: 'Respond.',
        colVarianza: 'Varianza',
        discrepante: 'Discrepancia (varianza ≥ umbral)',
        fuenteAnalisis: 'Analizar',
        fuente_CUESTIONARIO: 'Cuestionario',
        fuente_REAL: 'Real',
        fuente_AMBAS: 'Ambas',
        fuenteHelp_CUESTIONARIO: 'Percepción del equipo / criterio del ingeniero',
        fuenteHelp_REAL: 'Lectura objetiva del mapa de procesos',
        fuenteHelp_AMBAS: 'Compara real vs percepción y resalta la brecha',
        via: 'V·IA',
      },
    },
    mapaTitle: 'Mapa de procesos',
    explorerTitle: 'Explorador documental',
    tooltips: {
      mapa: {
        titulo: 'Mapa de procesos',
        ayuda:
          'Vista global de todos los procesos del sistema de gestión.\n\n· Estratégicos (PE) — definen la dirección y el gobierno corporativo.\n· Operativos (PO) — generan valor directo para el negocio.\n· Soporte (PS) — dan servicio a los procesos operativos.\n\nHaz clic en un grupo para ver sus procesos, y en un proceso para ver su flujograma y documentación asociada.',
      },
      explorador: {
        titulo: 'Explorador documental',
        ayuda:
          'Catálogo completo de documentos del sistema de gestión.\n\n· Solo los documentos en estado Vigente son de aplicación obligatoria.\n· Usa los filtros para buscar por tipo, proceso o estado.\n· Haz clic en un documento para ver su contenido completo y referencias cruzadas.',
      },
      ficha: {
        titulo: 'Ficha de proceso',
        ayuda:
          'Documento principal del proceso que recoge su propósito, alcance, responsable, entradas, salidas e indicadores.\n\n· El responsable del proceso es quien garantiza su ejecución y mejora continua.\n· Las entradas y salidas definen los límites del proceso con otros procesos del sistema.',
      },
    },
    procesos: 'Procesos',
    expandir: 'Expandir',
    colapsar: 'Colapsar',
    cargando: 'Cargando...',
    seleccionarProceso: 'Selecciona un proceso',
    fichaAqui: 'La ficha de caracterización se mostrará aquí',
    seleccionarDocumento: 'Selecciona un documento',
    deLaSeccion: 'de la sección Documentación',
    ficha: 'Ficha',
    docs: 'Docs',
    flow: 'Flow',
    visor: 'Visor',
    flujograma: 'Flujograma',
    fichaCaracterizacion: 'Caracterización',
    cargandoFicha: 'Cargando ficha de proceso...',
    procesoNoEncontrado: 'Proceso no encontrado',
    vigente: 'VIGENTE',
    exportarPdf: 'Exportar PDF',
    editarProximamente: 'Editar (proximamente)',
    responsable: 'Responsable',
    asistente: 'Asistente IA',
    fichaSubtitle: 'Ficha de Caracterizacion',
    aiDisponible: 'El asistente IA estara disponible proximamente',
    escribirMensaje: 'Escribe un mensaje...',
    identificacion: '1. Identificacion',
    codigo: 'Codigo',
    nombreProceso: 'Nombre del Proceso',
    tipologia: 'Tipologia',
    grupoFuncional: 'Grupo Funcional',
    fase: 'Fase',
    involucrados: 'Involucrados',
    sinRolesGobernanza: 'Sin roles de gobernanza asignados',
    descripcionSeccion: '2. Descripcion',
    sinDescripcion: 'Sin descripcion registrada',
    alcance: 'Alcance',
    alcanceNoDefinido: 'Alcance no definido en el modelo de datos actual',
    entradasSalidas: '3. Entradas y Salidas',
    entradas: 'Entradas',
    salidas: 'Salidas',
    sinEntradas: 'Sin datos — entradas no modeladas en la version actual',
    sinSalidas: 'Sin datos — salidas no modeladas en la version actual',
    reportesRequisitos: '4. Reportes y Requisitos',
    reportes: 'Reportes',
    requisitos: 'Requisitos',
    sinReportes: 'Sin reportes asociados',
    requisitosNoModelados: 'Requisitos normativos no modelados en la version actual',
    documentacion: '5. Documentacion',
    sinDocumentos: 'Sin documentos asociados',
    herramientasSeccion: '6. Herramientas',
    sinHerramientas: 'Sin herramientas asociadas',
    indicadoresSeccion: '7. Indicadores',
    sinIndicadores: 'Sin indicadores de proceso definidos',
    objetivo: 'Objetivo',
    calculo: 'Calculo',
    documentos: 'Documentos',
    cargandoDocumentos: 'Cargando documentos...',
    seleccioneProcesoFicha: 'Seleccione un proceso para ver su ficha de caracterización',
    ingenieria: 'Ingeniería',
    origen: 'Origen',
    destino: 'Destino',
    anadir: 'Añadir',
    pendiente: 'Pendiente',
    crearDocumento: 'Crear documento',
    creando: 'Creando...',
    nombreDocumento: 'Nombre del documento',
    tipoDocumental: 'Tipo documental',
    anadirALista: 'Añadir a la lista',
    anadirDocumento: 'Añadir documento',
    anadirIndicador: 'Añadir indicador',
    nuevoIndicador: 'Nuevo indicador',
    frecuencia: 'Frecuencia',
    valorActual: 'Valor actual',
    sinDescripcionCorto: 'Sin descripción',
    descripcionPlaceholder: 'Descripción del proceso...',
    alcancePlaceholder: 'Alcance del proceso...',
    direccionResponsable: 'Dirección Responsable',
    representanteProceso: 'Representante del Proceso',
    nuevoInvolucrado: 'Nuevo involucrado:',
    textoEntrada: 'Texto de la entrada:',
    nuevoReporte: 'Nuevo reporte:',
    nuevoRequisito: 'Nuevo requisito:',
    nuevaHerramienta: 'Nueva herramienta:',
    eliminarBorrador: 'Eliminar borrador',
    exportPdfPendiente: 'Exportación PDF — funcionalidad pendiente.',
  },

  // Document viewer
  documentViewer: {
    cargandoDocumento: 'Cargando documento...',
    documentoNoEncontrado: 'Documento no encontrado',
    proceso: 'Proceso',
    directorResponsable: 'Director responsable',
    representante: 'Representante',
    primeraAprobacion: 'Primera aprobacion',
    versionVigente: 'Version vigente',
    motivoRechazo: 'Motivo del rechazo (opcional)',
    indicarMotivo: 'Indique el motivo del rechazo...',
    confirmarRechazo: 'Confirmar rechazo',
    procesando: 'Procesando...',
    ocultarIndice: 'Ocultar indice',
    mostrarIndice: 'Mostrar indice',
    indice: 'INDICE',
    exportando: 'Exportando...',
    aprobado: 'Documento aprobado correctamente',
    rechazado: 'Documento rechazado — devuelto a revision',
    publicado: 'Documento publicado como vigente',
    enviadoAprobacion: 'Documento enviado a aprobacion',
    devueltoBorrador: 'Documento devuelto a borrador',
    transicionEjecutada: 'Transicion ejecutada correctamente',
  },

  // Document explorer panel
  docExplorer: {
    documentos: 'Documentos',
    todos: 'Todos',
    estrategicos: 'PE — Estratégicos',
    operativos: 'PO — Operativos',
    soporte: 'PS — Soporte',
    buscar: 'Buscar...',
    buscarPlaceholder: 'Buscar documentos...',
    cargandoDocumentos: 'Cargando documentos...',
    noEncontrados: 'No se encontraron documentos',
    codigo: 'Código',
    nombre: 'Título',
    proceso: 'Proceso',
    procesoCol: 'Proceso',
    representante: 'Representante',
    direccion: 'Dirección',
    tipo: 'Tipo',
    estado: 'Estado',
    edicion: 'Ed.',
    fecha: 'Fecha',
    totalDocumentos: 'Total documentos',
    vigentes: 'Vigentes',
    borrador: 'Borrador',
    enRevision: 'En revisión',
    aprobado: 'Aprobado',
    todosEstados: 'Todos los estados',
    todosProcesos: 'Todos los procesos',
    mostrando: 'Mostrando',
    de: 'de',
  },

  // Explorer workspace
  workspace: {
    exploradorDocumentos: 'Explorador de Documentos',
    mapaProcesos: 'Mapa de Procesos',
    cargandoProcesos: 'Cargando procesos...',
    sinGrupo: 'Sin grupo',
    pendientes: 'Pendientes',
    enRevision: 'En revision',
    enAprobacion: 'En aprobacion',
    fichaCaracterizacion: 'Ficha de Caracterización',
    documentos: 'Documentos',
    selectFromSheet: 'Seleccione un documento de la ficha',
    ficha: 'Ficha',
    docs: 'Docs',
    flow: 'Flow',
    visor: 'Visor',
    tooltips: {
      showFullSheet: 'Mostrar ficha completa',
      showOnlyDocs: 'Mostrar solo documentos',
      hideSheet: 'Ocultar ficha',
      expandDocument: 'Expandir documento',
      openFullViewer: 'Abrir en visor completo',
    },
  },

  // Changelog modal
  changelog: {
    nuevaEdicion: 'Nueva Edición',
    describaCambios: 'Describe los cambios que motivan esta nueva edición',
    descripcionCambios: 'Descripción de cambios',
    obligatorio: 'La descripción de cambios es obligatoria para crear una nueva edición.',
    crearEdicion: 'Crear Edición',
    creando: 'Creando...',
  },

  // Metadata tab
  metadata: {
    informacionDocumento: 'Informacion del Documento',
    codigo: 'Codigo',
    nombre: 'Nombre',
    tipoDocumental: 'Tipo Documental',
    proceso: 'Proceso',
    estado: 'Estado',
    edicionActual: 'Edicion Actual',
    empresa: 'Empresa',
    direccion: 'Direccion',
    fechaCreacion: 'Fecha Creacion',
    ultimaActualizacion: 'Ultima Actualizacion',
    seleccionarProceso: '— Seleccionar proceso —',
    errorAlGuardar: 'Error al guardar',
    cicloVida: 'Ciclo de Vida',
  },

  // TOC sidebar
  toc: {
    buscarSeccion: 'Buscar sección...',
    portada: 'Portada',
  },

  // Version diff
  diff: {
    comparacionVersiones: 'Comparación de versiones',
    cerrar: '✕ Cerrar',
    anadidasLabel: 'añadidas',
    eliminadasLabel: 'eliminadas',
    sinCambios: 'sin cambios',
    sinContenido: 'Sin contenido para comparar',
    lineaAnadida: 'Línea añadida',
    lineaEliminada: 'Línea eliminada',
  },

  // Viewer header
  viewerHeader: {
    guardando: 'Guardando...',
    autoguardadoActivo: 'Autoguardado activo',
    guardar: 'Guardar',
    guardarYCerrar: 'Guardar y cerrar',
    descartarCambios: 'Descartar cambios',
    editar: 'Editar',
    nuevaEdicion: 'Nueva edicion',
    creando: 'Creando...',
    exportarDocx: 'Exportar DOCX',
    exportando: 'Exportando...',
    documentoExportado: 'Documento exportado correctamente',
    errorAlExportar: 'Error al exportar',
    confirmarDescartar: 'Descartar cambios',
    perderanCambios:
      'Se perderan todos los cambios realizados desde la ultima vez que se guardo. Esta accion no se puede deshacer.',
    descartar: 'Descartar',
  },

  // Flow editor
  flow: {
    cargandoFlujograma: 'Cargando flujograma...',
    reintentar: 'Reintentar',
    guardarBorrador: 'Guardar borrador',
    enviarARevision: 'Enviar a revisión',
    historialVersiones: 'Historial de versiones',
    deshacer: 'Deshacer (Ctrl+Z)',
    rehacer: 'Rehacer (Ctrl+Y)',
    acercar: 'Acercar',
    alejar: 'Alejar',
    ajustarPantalla: 'Ajustar a pantalla',
    colapsarSubprocesos: 'Colapsar subprocesos',
    mostrarCuadricula: 'Mostrar/ocultar cuadrícula',
    mostrarMinimapa: 'Mostrar/ocultar minimapa',
    exportarPng: 'Exportar PNG',
    exportarPdf: 'Exportar PDF',
    guardando: 'Guardando...',
    viaAsistente: 'VIA — Asistente de Flujogramas',
    viaDescription:
      'El asistente de inteligencia artificial para diseño de flujogramas estará disponible próximamente.',
    entendido: 'Entendido',
    excedeTamano: (max: number) =>
      `El flujograma excede el tamano normativo (${max} nodos max.). Considere agrupar actividades en subprocesos.`,
    cerrarAviso: 'Cerrar aviso',
    sinFlujogramaPublicado: 'Este proceso no tiene un flujograma publicado',
    crearDesdeEditor: 'Cree uno desde el editor de flujogramas',
    vistaLectura: 'Flujograma — Vista de solo lectura',
    abrirEnEditor: 'Abrir en Editor',
    guardarAntes: 'Guarde el flujograma antes de enviarlo a revision.',
    enviarRevisionConfirm:
      'Enviar flujograma a revision? No se podra editar hasta que sea devuelto.',
    publish: 'Publicar',
    publishSuccess: 'Flujograma publicado correctamente',
    nuevaEdicionCreada: 'Nueva edición creada',
    errorNuevaEdicion: 'Error al crear nueva edición',
    errorEliminar: 'Error al eliminar borrador',
    errorArchivar: 'Error al archivar',
    nuevaSolicitud: 'Nueva solicitud',
    solicitudesVinculadas: 'Solicitudes vinculadas',
    // Toolbar — alignment & distribution
    alinearIzquierda: 'Alinear izquierda',
    alinearCentroH: 'Alinear centro horizontal',
    alinearDerecha: 'Alinear derecha',
    alinearArriba: 'Alinear arriba',
    alinearCentroV: 'Alinear centro vertical',
    alinearAbajo: 'Alinear abajo',
    distribuirH: 'Distribuir horizontal',
    distribuirV: 'Distribuir vertical',
    igualarTamano: 'Igualar tamaño',
    autoLayout: 'Auto-layout',
    autoLayoutTitle: 'Auto-layout (ELK)',
    calculando: 'Calculando...',
    exportar: 'Exportar',
    cuadricula: 'Cuadrícula',
    minimapa: 'Minimapa',
    toggleRedimensionar: 'Activar/desactivar redimensionamiento',
    versiones: 'Versiones',
    auditTrail: 'Audit trail',
    audit: 'Audit',
    // Header actions
    guardar: 'Guardar',
    guardarYCerrar: 'Guardar y cerrar',
    descartar: 'Descartar',
    editar: 'Editar',
    nuevaEdicionLabel: 'Nueva edición',
    eliminar: 'Eliminar',
    archivar: 'Archivar',
    pantallaCompleta: 'Pantalla completa',
    salirPantallaCompleta: 'Salir de pantalla completa',
    publicarConFirma: 'Publicar con firma electrónica',
    // Properties panel
    conector: 'Conector',
    etiqueta: 'Etiqueta',
    etiquetaConector: 'Etiqueta del conector',
    estiloLinea: 'Estilo de línea',
    solida: 'Sólida',
    discontinua: 'Discontinua',
    punteada: 'Punteada',
    tipoFlecha: 'Tipo de flecha',
    flecha: 'Flecha',
    sinFlecha: 'Sin flecha',
    bidireccional: 'Bidireccional',
    abierta: 'Abierta',
    colorLabel: 'Color',
    propiedades: 'Propiedades',
    sinNombre: 'Sin nombre',
    responsable: 'Responsable',
    sinAsignar: 'Sin asignar',
    descripcionLabel: 'Descripción',
    faseLabel: 'Fase',
    nombre: 'Nombre',
    cargandoPuestos: 'Cargando puestos...',
    responsableId: 'Responsable (ID)',
    idPuesto: 'ID del puesto',
    documentosVinculados: 'Documentos vinculados',
    documentoReferencia: 'Documento de referencia',
    condicion: 'Condición',
    tamano: 'Tamaño',
    procesoReferencia: 'Proceso de referencia',
    cargandoProcesos: 'Cargando procesos...',
    procesoIdLabel: 'Proceso ID',
    idProceso: 'ID del proceso',
    nodoTipoInfo: (tipo: string) => `Nodo de tipo ${tipo} — solo admite etiqueta.`,
    subprocesoInfo: 'El contenido del subproceso se edita expandiéndolo en el canvas.',
    sinResultadosPara: (term: string) => `Sin resultados para "${term}"`,
    sinDocumentosDisponibles: 'Sin documentos disponibles para este proceso.',
    cargandoDocumentos: 'Cargando documentos...',
    buscarDocumento: 'Buscar documento...',
    eliminarDoc: 'Eliminar',
    // Node type labels
    tipoActividad: 'Actividad',
    tipoDecision: 'Decisión',
    tipoDocumento: 'Documento',
    tipoSubproceso: 'Subproceso',
    tipoInicio: 'Inicio',
    tipoFin: 'Fin',
    tipoProcesoRef: 'Proceso (referencia)',
    tipoProcesoGobierno: 'Órgano de Gobierno',
    tipoResultado: 'Resultado',
    tipoProcesoRefCorto: 'Proceso Ref.',
    tipoProcesoGobiernoCorto: 'Proc. Gobierno',
    // Phases fallback
    faseDiagnostico: 'Diagnóstico',
    faseArquitectura: 'Arquitectura',
    faseDespliegue: 'Despliegue',
    faseOperacion: 'Operación',
    faseMadurez: 'Madurez',
    // Shape library
    formas: 'Formas',
    fases: 'Fases',
    agregarFase: '+ Agregar fase',
    nombrePlaceholder: 'Nombre...',
    arrastrarForma: 'Arrastre una forma al canvas para agregarla.',
    clicRenombrar: 'Clic para renombrar',
    renombrarFase: 'Renombrar fase',
    eliminarFase: 'Eliminar fase',
    expandirIzquierda: 'Expandir a la izquierda',
    expandirDerecha: 'Expandir a la derecha',
    gobCorporativo: 'Gob. Corporativo',
    procesoRef: 'Proceso (ref)',
    // Node detail panel
    cerrar: 'Cerrar',
    herramientas: 'Herramientas',
    etiquetasLabel: 'Etiquetas',
    documentoReferenciado: 'Documento referenciado',
    subprocesoLabel: 'Subproceso',
    nodosInternos: (n: number) => `${n} nodos internos`,
    procesoVinculado: 'Proceso vinculado',
    si: 'Sí',
    no: 'No',
  },

  // Process map
  processMap: {
    title: 'Mapa de Procesos',
    kpi: {
      procesosDocumentados: 'Procesos Documentados',
      flujogramasPublicados: 'Flujogramas Publicados',
      documentosVigentes: 'Documentos Vigentes',
      auditoriasPendientes: 'Auditorías Pendientes',
      conformidad: 'Conformidad',
      esteTrimestre: (n: number) => `+${n} este trimestre`,
      delTotal: (pct: number) => `${pct}% del total`,
      sinCambios: 'Sin cambios',
      vsMesAnterior: (n: number) => `-${n} vs mes anterior`,
      vsUltimoCiclo: (pct: number) => `+${pct}% vs último ciclo`,
      procesosEnRevision: 'Procesos en Revisión',
      pendientesAprobacion: 'Pendientes de aprobación',
      indicadoresCumplidos: 'Indicadores Cumplidos',
      vsObjetivoAnual: '+5% vs objetivo anual',
    },
    cargandoMapa: 'Cargando mapa de procesos...',
    errorAlCargar: 'Error al cargar',
    sinProcesosRegistrados: 'No se encontraron procesos registrados',
    noticias: 'Noticias',
    verTodo: 'Ver todo',
    noticiasRecientes: (n: number) => `${n} noticias recientes`,
    verTodas: 'Ver todas',
    procesosEstrategicos: 'PE — Procesos Estratégicos',
    ingenieriasGobernanza: 'PO — Ingenierías de Gobernanza',
    procesosSoporte: 'PS — Procesos de Soporte',
    cargandoGrupo: 'Cargando grupo de procesos...',
    grupoNoEncontrado: 'Grupo no encontrado',
    volverAlMapa: '← Volver al mapa de procesos',
    sinProcesosGrupo: 'No hay procesos registrados en este grupo',
    gestionDocumental: 'Gestión Documental',
    documentoVinculado: (n: number) =>
      `${n} documento${n !== 1 ? 's' : ''} vinculado${n !== 1 ? 's' : ''}`,
    procedimientos: 'Procedimientos',
    fichasCaracterizacion: 'Fichas de Caracterización',
    flujogramas: 'Flujogramas',
    instruccionesTecnicas: 'Instrucciones Técnicas',
    procesosDelGrupo: 'Procesos del grupo',
    explorador: 'Explorador de Documentos',
    cargandoProceso: 'Cargando proceso...',
    procesoNoEncontrado: 'Proceso no encontrado',
    mapa: 'Mapa',
    secciones: 'Secciones',
    descripcion: 'Descripción',
    responsables: 'Responsables',
    involucrados: 'Involucrados',
    documentacion: 'Documentación',
    requisitosLabel: 'Requisitos',
    reportesLabel: 'Reportes',
    herramientasLabel: 'Herramientas',
    indicadoresLabel: 'Indicadores',
    formacion: 'Formación',
    sinDescripcion: 'Sin descripción registrada.',
    tipologiaLabel: 'Tipología',
    grupo: 'Grupo',
    responsableLabel: 'Responsable',
    sinResponsable: 'Sin responsable asignado',
    sinDocumentacion: 'Sin documentación asociada',
    seccionesDelProceso: 'Secciones del proceso',
    vigenteBadge: 'Vigente',
    desdePill: 'Desde',
    actPill: 'Act.',
    volverAlFlujograma: 'Volver al flujograma',
    sinInvolucrados: 'Sin involucrados registrados',
    sinDocumentosVinculados: 'Sin documentos vinculados',
    sinRequisitos: 'Sin requisitos definidos',
    sinReportes2: 'Sin reportes definidos',
    sinHerramientasDefinidas: 'Sin herramientas definidas',
    sinIndicadoresDefinidos: 'Sin indicadores definidos',
    seccionEnDesarrollo: 'Sección en desarrollo.',
    formacionEnDesarrollo:
      'La sección de Formación se encuentra en desarrollo. Los planes de formación asociados al proceso se configuran en el módulo de Recursos.',
    objetoYAlcance: 'Objeto y alcance',
    direccionYRepresentante: 'Dirección y representante',
    rolesYParticipantes: 'Roles y participantes',
    normasAplicables: 'Normas aplicables',
    trimestralCMI: 'Trimestral CMI',
    onboardingAnual: 'Onboarding anual',
    kpisDefinidos: (n: number) => `${n} KPIs definidos`,
    estrategico: 'Estratégico',
    operativo: 'Operativo',
    soporteCorto: 'Soporte',
    mapaDeProcesos: 'Mapa de Procesos',
    gestionDocumentalTitulo: 'Gestión Documental',
    gestionDocDepartamental: 'Gestión Documental Departamental',
    gestionDocDepartamentalDesc:
      'Gestión del ciclo de vida documental por departamento y área funcional.',
    gestionDocProyectos: 'Gestión Documental de Proyectos',
    gestionDocProyectosDesc: 'Gestión documental vinculada a proyectos y entregables específicos.',
    equipoDelGrupo: 'Equipo del Grupo',
    directorResponsableLabel: 'Director Responsable',
    dirGralLabel: 'CEO — Dirección General',
    representanteDelProceso: 'Representante del Proceso',
    pendienteDeAsignar: 'Pendiente de asignar',
    actividadReciente: 'Actividad Reciente',
    kpiProcesosDelGrupo: 'Procesos del Grupo',
    kpiDocumentosVinculados: 'Documentos Vinculados',
    kpiConFaseAsignada: 'Con Fase Asignada',
    kpiConResponsable: 'Con Responsable',
    kpiFasesCubiertas: 'Fases Cubiertas',
    kpiDocsPorProceso: 'Docs por Proceso',
    kpiConformidad: 'Conformidad',
    sinProcesos: 'Sin procesos',
    sinFasesAsignadas: 'Sin fases asignadas',
    mayoriaEn: (fase: string) => `Mayoría en ${fase}`,
    delGrupo: 'del grupo',
    deProcesos: (n: number) => `de ${n} procesos`,
    delCicloDeVida: 'del ciclo de vida',
    promedioDelGrupo: 'promedio del grupo',
    pendienteDeMedicion: 'pendiente de medición',
    disponible: 'Disponible',
    pendienteDeConfigurar: 'Pendiente de configurar',
    servicioInformation: 'Servicio de VALOR·IA Information',
    actividad: {
      fichaActualizada: 'Ficha de caracterización actualizada',
      flujogramaEnviado: 'Flujograma enviado a aprobación',
      nuevoDocVinculado: 'Nuevo documento vinculado al proceso',
      indicadorRevisado: 'Indicador de rendimiento revisado',
      procesoAsignado: 'Proceso asignado a nuevo representante',
      hace2Dias: 'Hace 2 días',
      hace3Dias: 'Hace 3 días',
      hace5Dias: 'Hace 5 días',
      hace1Semana: 'Hace 1 semana',
      hace2Semanas: 'Hace 2 semanas',
    },
    vistaLectura: 'Flujograma — Vista de solo lectura',
    abrirEnEditor: 'Abrir en Editor',
    exportarPdf: 'Exportar PDF',
    highlightCards: {
      procesosActivos: 'Procesos Activos',
      procesosActivosDesc: 'Total de procesos en operación',
      documentosVigentes: 'Documentos Vigentes',
      documentosVigentesDesc: 'Documentos en estado publicado',
      pendientesRevision: 'Pendientes de Revisión',
      pendientesRevisionDesc: 'Documentos en cola de revisión',
      indicadoresAlDia: 'Indicadores al Día',
      indicadoresAlDiaDesc: 'KPI con medición actualizada',
    },
    newsPlaceholder: {
      gobernanza: 'Gobernanza',
      procesos: 'Procesos',
      cumplimiento: 'Cumplimiento',
      tecnologia: 'Tecnología',
      noticia1Titulo: 'Nuevo Marco de Gobierno Corporativo aprobado por el Consejo',
      noticia1Extracto:
        'El Consejo de Administración ha aprobado el nuevo marco de gobierno que entrará en vigor el próximo trimestre.',
      noticia2Titulo: 'Completada la fase de Diagnóstico en Ingeniería de Procesos',
      noticia2Extracto:
        'Se han identificado 47 procesos operativos clave y documentado sus interrelaciones.',
      noticia3Titulo: 'Auditoría interna ISO 9001: resultados positivos',
      noticia3Extracto:
        'La auditoría interna ha confirmado un 94% de conformidad con los requisitos del estándar.',
      noticia4Titulo: 'Migración a V·IANet 2.0 completada con éxito',
      noticia4Extracto:
        'Todos los módulos de la plataforma han sido actualizados a la nueva arquitectura.',
    },
  },

  // Import page (batch)
  importPage: {
    titulo: 'Importar Documentos',
    paso1: 'Paso 1: Configurar origen',
    paso1Desc:
      'Especifique la ruta al directorio que contiene los archivos DOCX a importar. El sistema escaneará recursivamente todos los subdirectorios.',
    rutaDirectorio: 'Ruta del directorio',
    escanear: 'Escanear',
    escaneando: 'Escaneando...',
    formatoEsperado: 'Formato esperado de archivo:',
    paso2: 'Paso 2: Vista previa',
    cambiarRuta: 'Cambiar ruta',
    listo: 'Listo',
    yaExiste: 'Ya existe',
    noImportable: 'No importable',
    creado: 'Creado',
    actualizado: 'Actualizado',
    omitido: 'Omitido',
    configurarOrigen: 'Configurar origen',
    vistaPrevia: 'Vista previa',
    importandoLabel: 'Importando',
    resultadosLabel: 'Resultados',
    importandoDocumentos: 'Importando documentos...',
    procesandoArchivos: (n: number) =>
      `Procesando ${n} archivos DOCX. Esto puede tardar unos momentos.`,
    errorImportacion: 'Error durante la importación:',
    paso4: 'Paso 4: Resultados de la importación',
    procesoFinalizado: 'Proceso de importación finalizado',
    nuevaImportacion: 'Nueva importación',
    irExplorador: 'Ir al explorador',
    totalArchivos: 'Total archivos',
    listosImportar: 'Listos para importar',
    yaExistentes: 'Ya existentes',
    noImportables: 'No importables',
    totalProcesados: 'Total procesados',
    creados: 'Creados',
    omitidos: 'Omitidos',
    errores: 'Errores',
    errorEscanear: 'Error al escanear el directorio',
    errorImportar: 'Error al importar documentos',
    archivo: 'Archivo',
    codigoCol: 'Código',
    tipoCol: 'Tipo',
    procesoCol: 'Proceso',
    tituloCol: 'Título',
    estadoCol: 'Estado',
    nombreCol: 'Nombre',
    detalleCol: 'Detalle',
  },

  // Tech discipline
  information: {
    tabs: {
      search: 'Búsqueda Inteligente',
      audit: 'Auditoría Documental',
      dashboards: 'Cuadros de Mando',
    },
  },
  reputation: {
    tabs: {
      news: 'Noticias',
      surveys: 'Encuestas',
      events: 'Eventos',
    },
  },
  tech: {
    title: 'Desarrollo Digital',
    description:
      'Plataforma V·IANet, APIs, integración y automatización. Gestiona las herramientas tecnológicas del ecosistema.',
    descriptions: {
      apps: 'Aplicaciones de gestión integradas en la plataforma',
      projects: 'Gestión de proyectos y seguimiento de iniciativas',
      procurement: 'Gestión de compras y aprovisionamiento',
      assets: 'Gestión de inventario y activos tecnológicos',
      requests: 'Gestión de solicitudes y peticiones internas',
      ocr: 'Escanear documentos físicos y PDFs para digitalizar',
    },
    tabs: {
      apps: 'Apps',
      projects: 'Proyectos',
      procurement: 'Compras',
      assets: 'Activos',
      requests: 'Peticiones',
      ocr: 'OCR / Digitalización',
    },
    ocr: {
      title: 'OCR / Digitalización',
      dropzone: 'Arrastra un archivo o haz clic para seleccionar',
      proceso: 'Proceso',
      tipo: 'Tipo documental',
      processing: 'Procesando OCR...',
      submit: 'Digitalizar',
    },
  },

  // Sign — Action Center
  sign: {
    title: 'Configuracion de Sign (M15)',
    estado: 'Estado de Sign',
    activo: 'M15 Sign esta activo. La activacion se gestiona desde Admin > Plataforma > Modulos.',
    inactivo: 'M15 Sign esta inactivo. Activalo desde Admin > Plataforma > Modulos.',
    nivelDefault: 'Nivel de firma por defecto',
    horasRecordatorio: 'Horas para recordatorio',
    horasEscalacion: 'Horas para escalacion',
    caInterna: 'CA interna habilitada',
    firmaInvitacion: 'Firma por invitacion',
    politicaEntidad: 'Nivel minimo de firma por tipo de entidad',
    certificados: 'Certificados',
    sinCertificados: 'Sin certificados configurados',
    qtspTitle: 'Proveedor QTSP (Firma Cualificada)',
    proximoQTSP: 'Integracion QTSP disponible en proximas versiones',
    actionCenter: {
      title: 'Action Center',
      tabs: {
        pendientes: 'Pendientes',
        historial: 'Historial',
        delegaciones: 'Delegaciones',
      },
      pendientesCount: 'pendiente',
      ordenar: 'Ordenar',
      porFecha: 'Fecha',
      porTipo: 'Tipo',
      cargando: 'Cargando...',
      cargandoMas: 'Cargando...',
      cargarMas: 'Cargar mas',
      irARevisar: 'Ir a revisar',
      verEntidad: 'Ver entidad',
      delegar: 'Delegar',
      delegadoIdLabel: 'ID del delegado (UUID)',
      motivoLabel: 'Motivo',
      confirmarDelegacion: 'Confirmar',
      delegacionesRecibidas: 'Delegaciones recibidas',
      delegacionesRealizadas: 'Delegaciones realizadas',
      delegadaPor: 'Delegada por',
      delegadaA: 'Delegada a',
      activa: 'Activa',
      finalizada: 'Finalizada',
      // 0662: claves para distincion legacy (firma) vs workflow + revocar.
      tipoLegacyBadge: 'Firma',
      tipoWorkflowBadge: 'Workflow',
      revocar: 'Revocar',
      confirmarRevocar: '¿Revocar esta delegación? El delegado dejará de ver el pendiente.',
      timelineTitle: 'Flujo del workflow',
      timelineSolicitante: 'Solicitante',
      timelinePublicador: 'Publicador',
      timelineDone: 'Completado',
      timelinePending: 'Pendiente',
      timelineFuture: 'Futuro',
      timelineNotFound: 'Sin información de workflow',
      timelineRevisor: 'Revisor',
      timelineAprobador: 'Aprobador',
      timelineNotificar: 'Notificación',
      timelineNotifyDelivered: 'Enviada',
      timelineNotifyPending: 'En envío',
      detail: {
        tipoEntidad: 'Tipo entidad',
        idArtefacto: 'ID artefacto',
        estado: 'Estado',
        estadoPendiente: 'Pendiente de aprobación',
        nivelFirma: 'Nivel firma',
        solicitante: 'Solicitante',
        fechaLimite: 'Fecha límite',
        hash: 'Hash',
        decision: 'Decisión',
        recibido: 'Recibido',
        accionAyuda:
          'Pulsa "Aprobar" para confirmar la transición o "Rechazar" indicando un motivo. "Ir a revisar" abre el artefacto para inspeccionarlo antes de decidir.',
        accionAyudaTitulo: 'Acción',
      },
      tabEnCurso: 'En curso',
      enCursoEmpty: 'No tienes solicitudes en curso',
      enCursoTooltipSolicitante: 'Tú lanzaste esta solicitud',
      enCursoTooltipParticipante: 'Participaste en una etapa anterior',
      enCursoTooltipFuturo: 'Te tocará en una etapa futura',
      // 0666b: Action Center Premium UX (tabla densa virtualizada + detail expand 3 columnas)
      premium: {
        title: 'Centro de acciones',
        searchPlaceholder: 'Buscar por asunto, alcance, código o título…',
        emptyTitle: 'Bandeja vacía',
        emptySubtitle: 'No tienes solicitudes pendientes en este momento.',
        loading: 'Cargando solicitudes…',
        errorTitle: 'No se pudo cargar',
        errorRetry: 'Reintentar',
        countItems: '{n} solicitudes',
        tabAll: 'Todas',
        tipoOrganigrama: 'Organigrama',
        tipoDoc: 'Documentos',
        tipoFlujograma: 'Flujogramas',
        tipoDocLegacy: 'Doc legacy',
        tipoPeticion: 'Peticiones',
        tipoCompra: 'Compras',
        actionOpen: 'Abrir artefacto',
        actionOpenOrganigrama: 'Abrir organigrama',
        actionOpenDocumento: 'Abrir documento',
        actionOpenFlujograma: 'Abrir flujograma',
        detailLoadError: 'No se pudo cargar el detalle. Cierra el modal y vuelve a intentarlo.',
        colTipo: 'Tipo',
        colAsunto: 'Asunto',
        colCodigo: 'Código',
        colSolicitante: 'Solicitante',
        colFecha: 'Fecha',
        colEstado: 'Estado',
        detailDetails: 'Detalles',
        detailFlow: 'Flujo de aprobación',
        detailNotified: 'Notificados y adjuntos',
        detailAsunto: 'Asunto',
        detailAlcance: 'Alcance',
        detailSolicitante: 'Solicitante',
        detailFechaSolicitud: 'Fecha solicitud',
        detailEstado: 'Estado',
        detailNotifiedTitle: 'Notificados',
        detailAttachmentsTitle: 'Adjuntos',
        detailAttachmentsEmpty: 'Sin adjuntos',
        detailNotifiedEmpty: 'Sin notificaciones registradas',
        observationsLabel: 'Observaciones',
        observationsPlaceholder: 'Añade un comentario opcional…',
        rejectMotivoLabel: 'Motivo del rechazo',
        rejectMotivoPlaceholder: 'Explica por qué rechazas la solicitud…',
        actionCancel: 'Cancelar',
        actionReject: 'Rechazar',
        actionApprove: 'Aprobar',
        actionApproving: 'Aprobando…',
        actionRejecting: 'Rechazando…',
        approveError: 'No se pudo aprobar',
        rejectError: 'No se pudo rechazar',
        actionDelegate: 'Delegar',
        // 0669 — vistas + paginación + modal premium enriquecido
        vistaLabel: 'Vista',
        vistaPendientes: 'Pendientes',
        vistaEnCurso: 'En curso',
        vistaHistorico: 'Histórico',
        paginacionAnterior: 'Anterior',
        paginacionSiguiente: 'Siguiente',
        paginacionPagina: 'Página {n} de {total}',
        paginacionPageSize: 'Por página',
        paginacionTotal: '{n} resultados',
        flowFecha: 'Fecha',
        flowRol: 'Rol',
        flowPuesto: 'Puesto',
        flowMotivo: 'Comentario',
        flowMotivoEmpty: 'Sin comentarios',
        flowMotivoTitle: 'Ver comentario',
        notifiedRol: 'Rol',
        notifiedPuesto: 'Puesto',
        notifiedToggleShow: 'Mostrar notificados ({n})',
        notifiedToggleHide: 'Ocultar notificados',
        delegar: {
          title: 'Delegar aprobación',
          searchPlaceholder: 'Buscar persona por nombre, email o código…',
          searchHint: 'Empieza a escribir para buscar personas del tenant.',
          loading: 'Cargando personas…',
          noResults: 'No se encontraron coincidencias',
          motivoLabel: 'Motivo de la delegación',
          motivoPlaceholder: 'Explica por qué delegas (≥ 5 caracteres)…',
          cancel: 'Cancelar',
          confirm: 'Delegar',
          delegating: 'Delegando…',
          removeSelection: 'Quitar selección',
          errorNoPersona: 'Selecciona una persona del listado.',
          errorPersonaSinUsuario:
            'Esta persona no tiene usuario asociado y no puede recibir delegaciones.',
          errorMotivoCorto: 'El motivo debe tener al menos 5 caracteres.',
          errorDelegar: 'No se pudo delegar',
        },
        adjuntos: {
          title: 'Adjuntos',
          dropzonePrompt: 'Arrastra archivos aquí o haz clic para subir',
          dropzoneHint: 'PDF, Office, imágenes, ZIP — máx 50 MB por archivo',
          subiendo: 'Subiendo…',
          listaVacia: 'Aún no hay adjuntos para este artefacto',
          descargar: 'Descargar',
          eliminar: 'Eliminar adjunto',
          confirmarEliminar: '¿Eliminar este adjunto? Se podrá recuperar desde la papelera.',
          subidoPor: 'Subido por',
          tamano: 'Tamaño',
          fecha: 'Fecha',
          errorMimeType: 'Tipo de archivo no permitido',
          errorTamanoExcedido: 'El archivo excede 50 MB',
          errorSubida: 'No se pudo subir el archivo',
          errorDescarga: 'No se pudo generar el enlace de descarga',
          errorEliminacion: 'No se pudo eliminar el adjunto',
        },
        comentarios: {
          title: 'Comentarios',
          placeholder: 'Escribe un comentario sobre este artefacto…',
          enviar: 'Enviar',
          enviando: 'Enviando…',
          cargando: 'Cargando comentarios…',
          listaVacia: 'Aún no hay comentarios. Sé el primero en aportar contexto.',
          eliminar: 'Eliminar comentario',
          confirmarEliminar: '¿Eliminar este comentario? Quedará marcado como eliminado.',
          errorCrear: 'No se pudo enviar el comentario',
          errorEliminar: 'No se pudo eliminar el comentario',
          tiempoAhora: 'ahora',
          tiempoMinutos: 'hace {n}m',
          tiempoHoras: 'hace {n}h',
          tiempoDias: 'hace {n}d',
          empty: 'Sin comentarios disponibles',
        },
      },
    },
  },

  // Landing page common
  disciplines: {
    tooltips: {
      structure:
        'VALOR·IA Structure gestiona la arquitectura organizativa: personas, puestos, departamentos, entidades y relaciones de gobierno.\n\nEs la base de datos de quién es quién y cómo se organiza la empresa para ejecutar su modelo de gobernanza corporativa.',
      process:
        'VALOR·IA Process gestiona el ciclo de vida completo de los procesos: caracterización, flujogramas, indicadores y documentación normativa.\n\nGarantiza que todos los procesos estén documentados, asignados y medidos según el modelo de gobernanza.',
      information:
        'VALOR·IA Information gestiona el corpus documental del sistema de gestión: normas, instrucciones, registros y reportes.\n\nAsegura que la información esté actualizada, controlada y accesible para todos los involucrados en los procesos.',
      compliance:
        'VALOR·IA Compliance gestiona el cumplimiento normativo y los flujos de aprobación: auditorías, workflows y sign-off corporativo.\n\nGarantiza la trazabilidad completa de todas las decisiones y cambios con impacto en el gobierno corporativo.',
      tech: 'VALOR·IA Tech gestiona los activos tecnológicos, proyectos digitales y herramientas del sistema de información corporativo.\n\nConecta la arquitectura tecnológica con los procesos y personas que la utilizan.',
      reputation:
        'VALOR·IA Reputation gestiona la comunicación corporativa interna: noticias, eventos, encuestas y la narrativa de gobernanza.\n\nContribuye a que todos los miembros de la organización conozcan y vivan el modelo de gobierno corporativo.',
    },
  },
  landing: {
    processes: 'Procesos',
    documents: 'Documentos',
    tabs: {
      summary: 'Resumen',
      processes: 'Procesos',
      documents: 'Documentos',
      kpis: 'KPIs',
    },
    description: 'Descripción',
    lifecycle: 'Ciclo de Vida',
    modules: 'Módulos',
    lifecyclePhases: {
      diagnosis: 'Diagnóstico',
      architecture: 'Arquitectura',
      deployment: 'Despliegue',
      operation: 'Operación',
      maturity: 'Madurez',
    },
    processesRegistered: (n: number, _mod?: string) =>
      `${n} procesos registrados en esta ingeniería.`,
    selectProcess: 'Selecciona un proceso desde el sidebar para ver su ficha de caracterización.',
    documentsAssociated: (n: number, _mod?: string) => `${n} documentos normativos asociados.`,
    useExplorer: 'Usa el Explorador Documental para navegar y gestionar documentos.',
    kpisInDev: 'Panel de indicadores en desarrollo.',
  },

  // Archivos adjuntos
  archivos: {
    titulo: 'Archivos Adjuntos',
    subir: 'Subir archivo',
    enlace: 'Registrar enlace',
    sinArchivos: 'Sin archivos adjuntos',
    eliminar: 'Eliminar archivo',
    confirmarEliminar: '¿Eliminar este archivo?',
    subiendo: 'Subiendo...',
    subido: 'Archivo subido',
    errorSubir: 'Error al subir',
    enlaceRegistrado: 'Enlace registrado',
    archivo: 'Archivo',
    enlaceExterno: 'Enlace externo',
    storage: 'Storage',
    urlEnlace: 'URL del enlace',
    nombreArchivo: 'Nombre del archivo',
    tipoMime: 'Tipo MIME',
    descripcion: 'Descripción',
    tabArchivos: 'Archivos',
    filtroTipoContenido: 'Tipo de contenido',
    todosContenidos: 'Todos los contenidos',
    digital: 'Digital',
    seleccionarArchivo: 'Seleccionar archivo',
    descargar: 'Descargar',
    abrirEnlace: 'Abrir enlace',
    reemplazar: 'Reemplazar archivo',
  },

  // Migration dashboard
  migracion: {
    titulo: 'Estado de Migracion',
    progreso: 'Progreso de migracion',
    completados: 'Completados',
    pendientes: 'Pendientes',
    errores: 'Con errores',
    de: 'de',
    documentosMigrados: 'documentos migrados',
    cargando: 'Cargando estado de migracion...',
    errorCargar: 'Error al cargar estado de migracion',
    PENDIENTE: 'Pendiente',
    COMPLETADO: 'Completado',
    ERROR: 'Error',
    oleada: 'Oleada',
    documento: 'Documento',
    estado: 'Estado',
  },
  adminProcesos: {
    titulo: 'Administración de Procesos',
    pestana: 'Administración',
    nuevoGrupo: '+ Nuevo grupo',
    nuevoProceso: '+ Nuevo proceso',
    confirmarDesactivar: '¿Desactivar proceso?',
    confirmarDesactivarDesc: 'se marcará como inactivo.',
    avisoDocumentos: 'documentos asociados. Los documentos no se eliminarán.',
    desactivar: 'Desactivar',
    cancelar: 'Cancelar',
    inactivo: 'Inactivo',
    renombrar: 'Renombrar grupo',
    eliminarGrupo: 'Eliminar grupo',
    grupoConProcesos: 'No se puede eliminar un grupo con procesos',
    grupoRenombrado: 'Grupo renombrado',
    procesoCreado: 'Proceso creado',
    procesoActualizado: 'Proceso actualizado',
    procesoDesactivado: 'Proceso desactivado',
    cargando: 'Cargando procesos...',
    grupos: 'grupos funcionales',
    procesos: 'procesos',
    nombreProceso: 'Nombre del proceso...',
    nombreGrupo: 'Nombre del grupo...',
  },
  requests: {
    adminTitle: 'Gestión de solicitudes',
    tooltips: {
      admin: {
        titulo: 'Gestión de solicitudes',
        ayuda:
          'Panel de administración de todas las solicitudes del sistema.\n\nLas solicitudes son flujos de trabajo estructurados para gestionar peticiones entre personas y departamentos con trazabilidad completa y aprobación controlada.',
      },
    },
    admin: {
      title: 'Configuración de Solicitudes',
      formularios: 'Formularios',
      cadenas: 'Cadenas',
    },
    nuevo: 'Nuevo',
    editar: 'Editar',
    eliminar: 'Eliminar',
    confirmarEliminar: '¿Eliminar este elemento? Esta acción no se puede deshacer.',
    guardado: 'Guardado correctamente',
    nombre: 'Nombre',
    descripcion: 'Descripción',
    codigo: 'Código',
    orden: 'Orden',
    activo: 'Activo',
    grupo: 'Grupo',
    tipo: 'Tipo de solicitud',
    proceso: 'Proceso vinculado',
    requiereFirma: 'Requiere firma',
    nivelFirma: 'Nivel de firma',
    fuenteResolucion: 'Fuente de resolución',
    persona: 'Persona',
    importeMinimo: 'Importe mínimo',
    obligatorio: 'Obligatorio',
    rolAprobacion: 'Rol de aprobación',
    delegante: 'Delegante',
    delegado: 'Delegado',
    fechaInicio: 'Fecha inicio',
    fechaFin: 'Fecha fin',
    motivo: 'Motivo',
    horasLimite: 'Horas límite',
    escaladoA: 'Escalar a',
    nivelEscalado: 'Nivel de escalado',
    evento: 'Evento',
    asunto: 'Asunto',
    cuerpoHtml: 'Cuerpo HTML',
    sinDatos: 'No hay datos configurados',
    cargando: 'Cargando...',
    seleccionar: 'Seleccionar...',
    todos: 'Todos',
    cancelar: 'Cancelar',
    // User-facing (solicitudes)
    nueva: 'Nueva solicitud',
    misSolicitudes: 'Mis solicitudes',
    pendientesAprobar: 'Pendientes de aprobar',
    seleccionarTipo: 'Selecciona un tipo de solicitud',
    cambiarTipo: 'Cambiar tipo',
    guardarBorrador: 'Guardar borrador',
    enviarAprobacion: 'Enviar a aprobacion',
    aprobar: 'Aprobar',
    rechazar: 'Rechazar',
    devolver: 'Devolver',
    confirmar: 'Confirmar',
    observaciones: 'Observaciones (opcional)',
    timeline: 'Historial de aprobaciones',
    formulario: 'Formulario',
    auditLog: 'Registro de auditoria',
    campoRequerido: 'Este campo es obligatorio',
    campoNoSoportado: 'Campo no soportado en esta version',
    sinTipos: 'No hay tipos de solicitud configurados',
    sinSolicitudes: 'No tienes solicitudes',
    sinPendientes: 'No tienes solicitudes pendientes de aprobar',
    enviadaOk: 'Solicitud enviada correctamente',
    borradorGuardado: 'Borrador guardado',
    errorGenerico: 'Error al procesar la solicitud',
    configuracion: 'Configuracion',
    desdeActividad: 'Desde actividad del flujograma',
    // Tabs headings / common shared with admin tabs
    aprobadores: 'Aprobadores',
    nuevoAprobador: 'Nuevo aprobador',
    seleccionaTipoMsg: 'Selecciona un tipo de solicitud para ver sus aprobadores',
    sinAprobadores: 'No hay aprobadores configurados para este tipo',
    confirmarEliminarMsg:
      '¿Seguro que quieres eliminar este elemento? Esta acción no se puede deshacer.',
    delegaciones: 'Delegaciones',
    nuevaDelegacion: 'Nueva delegación',
    editarDelegacion: 'Editar delegación',
    sinDelegaciones: 'No hay delegaciones configuradas',
    escalados: 'Escalados',
    nuevoEscalado: 'Nuevo escalado',
    editarEscalado: 'Editar escalado',
    sinEscalados: 'No hay escalados configurados',
    grupos: 'Grupos',
    tipos: 'Tipos',
    todosGrupos: 'Todos los grupos',
    plantillas: 'Plantillas',
    nuevaPlantilla: 'Nueva plantilla',
    editarPlantilla: 'Editar plantilla',
    sinPlantillas: 'No hay plantillas configuradas',
    asuntoPlaceholder: 'Asunto de la notificación',
    tipoSolicitud: 'Tipo de solicitud',
    acciones: 'Acciones',
    opcional: 'opcional',
    firmada: 'Firmada',
  },

  // Glosario
  glosario: {
    title: 'Glosario',
    subtitle: 'Terminología oficial del sistema de gobernanza',
    searchPlaceholder: 'Buscar término, definición o sinónimo...',
    loading: 'Cargando glosario...',
    empty: 'No se encontraron términos con esos filtros',
    errorLoading: 'Error cargando el glosario',
    all: 'Todas',
    term: 'término',
    terms: 'términos',
    ofTotal: (total: number) => `de ${total} totales`,
    synonyms: 'Sinónimos:',
    noTranslate: 'No traducir',
    categoria: {
      INGENIERIA: 'Ingeniería',
      TIPO_DOCUMENTAL: 'Tipo documental',
      GENERAL: 'General',
      FASE: 'Fase',
      ROL: 'Rol',
      TECNICO: 'Técnico',
    },
    admin: {
      title: 'Glosario',
      newTerm: 'Nuevo término',
      editTerm: 'Editar término',
      fieldTermino: 'Término',
      fieldDefinicion: 'Definición',
      fieldCategoria: 'Categoría',
      fieldSinonimos: 'Sinónimos',
      fieldNoTraducir: 'No traducir',
      fieldIdioma: 'Idioma',
      save: 'Guardar',
      cancel: 'Cancelar',
      confirmDelete: '¿Eliminar este término del glosario?',
      created: 'Término creado',
      updated: 'Término actualizado',
      deleted: 'Término eliminado',
      errorSave: 'Error al guardar',
      errorDelete: 'Error al eliminar',
      required: 'Campo obligatorio',
      synonymsHint: 'Pulsa Enter o coma para añadir',
      truncated: (n: number) => `${n} sinónimos`,
    },
  },
};
